/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 3
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/pluva-market/Pluva%20Market/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: 'ad51563d635bd3a6c361638f679b3d08',
  development: '560e3471111f3b5bb372220d085824fe'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '3',
    branch: 'main',
    source: 'web',
    versionId: 'd3bc6b9a-1f11-49fa-81d2-b7731bdac3c1'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  pvm_advertisement_term_agreed?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  pvm_odp_visited_count?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  pvm_pdp_visited_count?: number;
  pvm_user_age_range?: string;
  pvm_user_email?: string;
  pvm_user_id?: string;
  pvm_user_logged_in?: boolean;
  pvm_user_phone_number?: string;
  pvm_user_region?: string;
}

export interface PvmChangeManagedFarmTaskStatusProperties {
  changed_status: string;
}

export interface PvmClickAddPriceOnSellTractorSellingPricePageProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  added_amount: number;
}

export interface PvmClickApplyPriceOnSellTractorSellingPricePageProperties {
  brand: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  manufacturedYear?: number;
  model: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  operationTime?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  selected_model_manufactured_year: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  selected_model_operation_time: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  selected_model_price: number;
}

export interface PvmClickBumpButtonInMyPageProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  index_in_list: number;
  product_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_on_sales_product_count: number;
}

export interface PvmClickBumpButtonInOdpProperties {
  product_id: string;
}

export interface PvmClickCropAccordionToggleProperties {
  type: string;
}

export interface PvmClickCropCardInFavoriteCropProperties {
  cultivar: string;
  price_changed_history: string;
}

export interface PvmClickCropCardInWholesaleMarketProperties {
  cultivar: string;
  price_changed_history: string;
}

export interface PvmClickCropDetailShareButtonProperties {
  cultivar: string;
}

export interface PvmClickCropFavoriteButtonProperties {
  cultivar: string;
}

export interface PvmClickCsVideoPlayButtonProperties {
  video_title: string;
}

export interface PvmClickEnrollManagedFarmTaskFabProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_enrolled_tasks: number;
}

export interface PvmClickEnrollmanagedFarmTaskButtonOnEmptySectionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_enrolled_tasks: number;
}

export interface PvmClickFarmTaskRegisterButtonProperties {
  area_in_pyeong?: string;
  field_address?: string;
}

export interface PvmClickFilterBrandQuickButtonProperties {
  brand_name: string;
  changed_to: string;
  filter_type: string;
}

export interface PvmClickFilterControllerMenuButtonProperties {
  filter_key: string;
  filter_type: string;
}

export interface PvmClickFilterControllerResetButtonProperties {
  filter_type: string;
  filters: any;
}

export interface PvmClickFilterControllerSubmitButtonProperties {
  filter_type: string;
  filters: any;
  is_any_filter_selected: boolean;
}

export interface PvmClickFilterIconButtonProperties {
  button_type: string;
  filter_type: string;
}

export interface PvmClickFilterSelectionProperties {
  filter_type: string;
  title?: string;
}

export interface PvmClickGnbInputCancelButtonProperties {
  search_keyword: string;
}

export interface PvmClickGoToManagedFarmTaskDetailPageButtonProperties {
  task_start_day: string;
  task_start_month: string;
  task_start_year: string;
  task_status: string;
  task_title: string;
}

export interface PvmClickGoToOlpPageProperties {
  page_type?: string;
}

export interface PvmClickGoToSellMachineEntryPageProperties {
  buttonType: string;
  page_type?: string;
}

export interface PvmClickHomeCropSwiperProperties {
  cutivar: string;
  index?: string;
}

export interface PvmClickHomeLandingIconProperties {
  title?: string;
}

export interface PvmClickHomeNewProductCardProperties {
  id?: string;
  index?: string;
  installment_yn: boolean;
  negotiation_yn: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  title?: string;
}

export interface PvmClickHomeNewProductInquiryProperties {
  id?: string;
  index?: string;
  installment_yn: boolean;
  negotiation_yn: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  rendered_in: string;
  title?: string;
}

export interface PvmClickHomeRecommendedNewProductCardProperties {
  id?: string;
  index?: string;
  installment_yn: boolean;
  negotiation_yn: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  title?: string;
}

export interface PvmClickHomeRecommendedTabProperties {
  title?: string;
}

export interface PvmClickHomeVideoPdpViewButtonProperties {
  "매물 코드": string;
}

export interface PvmClickHomeVideoPlayButtonProperties {
  "매물 코드": string;
}

export interface PvmClickIdpFabProperties {
  title?: string;
}

export interface PvmClickLoginButtonInOdpSuggestPriceProcessProperties {
  brand: string;
  model: string;
}

export interface PvmClickMainCarouselProperties {
  carousel_title?: string;
  page_type?: string;
  position?: string;
}

export interface PvmClickManagedFarmTaskStatusChangeButtonProperties {
  task_start_day: string;
  task_start_month: string;
  task_start_year: string;
  task_status: string;
  task_title: string;
}

export interface PvmClickMangedFarmSimpleCallProperties {
  field_owner_name: string;
  field_owner_phone_number: string;
  task_title: string;
}

export interface PvmClickMangedFarmSimpleSmsProperties {
  field_owner_name: string;
  field_owner_phone_number: string;
  message: string;
  task_title: string;
}

export interface PvmClickMarketPriceCardProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  engineOutputInPs: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  maxPrice: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  minPrice: number;
  model: string;
}

export interface PvmClickMarketPriceDetailLoginButtonProperties {
  buttonType: string;
  model: string;
}

export interface PvmClickMarketPriceDetailShareButtonProperties {
  model: string;
}

export interface PvmClickMarketPriceFilterButtonProperties {
  filter_key: string;
}

export interface PvmClickMarketPriceFilterSubmitProperties {
  filter_brands: string;
  filter_engine_output_in_ps: string;
  filter_price: string;
  filter_sort: string;
  is_auto_opened?: boolean;
}

export interface PvmClickMarketPriceFilterSuggestionProperties {
  position?: string;
  title?: string;
}

export interface PvmClickMarketPriceQuickRecommendationProperties {
  position?: string;
  title?: string;
}

export interface PvmClickMarketPriceRecommendedKeywordProperties {
  search_keyword: string;
}

export interface PvmClickMonthNavigatorButtonProperties {
  button_type: string;
}

export interface PvmClickMoreProductButtonProperties {
  category?: string;
  page_type?: string;
}

export interface PvmClickMpdpPremiumProductProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sequence?: number;
  title?: string;
}

export interface PvmClickMyDeleteOwnTractorDoneProperties {
  title?: string;
  user_id: string;
}

export interface PvmClickMyOwnListConfirmPokeRequestProperties {
  id?: string;
  title?: string;
}

export interface PvmClickMySellMachineTabProperties {
  title?: string;
}

export interface PvmClickMySellOwnTractorProperties {
  page_type?: string;
  position?: string;
}

export interface PvmClickMyTogglePokeStatusProperties {
  position?: string;
  status?: string;
}

export interface PvmClickNdpPluvaTractorsProperties {
  id?: string;
  index?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  title?: string;
}

export interface PvmClickNdpUserSellTractorsProperties {
  id?: string;
  index?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  title?: string;
}

export interface PvmClickNewProductDetailCardProperties {
  id?: string;
  index?: string;
  installment_yn: boolean;
  negotiation_yn: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  section: string;
  title?: string;
}

export interface PvmClickNewProductImageProperties {
  id?: string;
  index?: string;
}

export interface PvmClickNewProductInquiryProperties {
  id?: string;
  installment_yn: boolean;
  negotiation_yn: boolean;
  title?: string;
}

export interface PvmClickNewProductPreviewCardProperties {
  id?: string;
  index?: string;
  installment_yn: boolean;
  negotiation_yn: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  section: string;
  title?: string;
}

export interface PvmClickNewProductVideoProperties {
  id?: string;
  index?: string;
}

export interface PvmClickOdpSuggestPriceButtonProperties {
  brand: string;
  model: string;
  title?: string;
}

export interface PvmClickOdpSuggestPriceModalConfirmButtonProperties {
  brand: string;
  model: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  suggest_price: number;
  title?: string;
}

export interface PvmClickOlpOnSaleOnlyButtonProperties {
  type: string;
}

export interface PvmClickOlpProductFilterButtonProperties {
  filter_key: string;
}

export interface PvmClickOlpTabProperties {
  type: string;
}

export interface PvmClickOpenMarketDetailCardOnPlpProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  bump_times: number;
  code: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  days_since_last_bump?: number;
  filters: any;
  index?: string;
  is_any_filter_selected: boolean;
  is_bumped_before: boolean;
  is_mine: boolean;
  is_new_product: boolean;
  title?: string;
}

export interface PvmClickOpenMarketSearchAutoCompleteKeywordProperties {
  title?: string;
  typed_keyword: string;
}

export interface PvmClickOpenMarketSearchIconProperties {
  typed_keyword: string;
}

export interface PvmClickOpenMarketSearchLandingButtonProperties {
  page_type?: string;
}

export interface PvmClickOpenMarketSearchRecommendedSearchKeywordProperties {
  title?: string;
  type: string;
}

export interface PvmClickOpenMarketSearchResultCardProperties {
  code: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  product_id: string;
  product_title: string;
  typed_keyword: string;
}

export interface PvmClickOpenMarketSearchResultRetryProperties {
  typed_keyword: string;
}

export interface PvmClickOpenMarketSearchWatchByFilterButtonProperties {
  button_name: string;
}

export interface PvmClickPdpProductPhotoProperties {
  page_type?: string;
  product_code: string;
  product_title: string;
  user_type?: string;
}

export interface PvmClickPdpToMarketPriceSearchResultButtonProperties {
  title?: string;
}

export interface PvmClickPlpProductFilterButtonProperties {
  filter_key: string;
}

export interface PvmClickPluvawayButtonProperties {
  contact_method?: string;
}

export interface PvmClickPokeProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  title?: string;
  type: string;
}

export interface PvmClickPokeCancelProperties {
  title?: string;
}

export interface PvmClickPokeCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  manufacturedYear?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  operationTime?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  ps?: number;
  title?: string;
  type: string;
  user_id: string;
}

export interface PvmClickPokeFilterButtonProperties {
  filter_key: string;
}

export interface PvmClickPokeFilterSubmitProperties {
  filter_brands: string;
  filter_engine_output_in_ps: string;
  filter_region: string;
  filter_sort: string;
}

export interface PvmClickPokingDetailModalCloseProperties {
  title?: string;
}

export interface PvmClickPriceSuggestCardProperties {
  createAt?: string;
  pokingId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
}

export interface PvmClickProductCardInSwiperProperties {
  category?: string;
  id?: string;
  page_type?: string;
  position?: string;
  title?: string;
}

export interface PvmClickProductCardInstallmentButtonProperties {
  "매물 코드": string;
}

export interface PvmClickProductFilterOptionInputProperties {
  filter_key: string;
  filter_option_name: string;
}

export interface PvmClickProductFullscreenPhotoArrowButtonProperties {
  direction: string;
  image_number: string;
  page_type?: string;
  product_code: string;
  product_title: string;
  user_type?: string;
}

export interface PvmClickRealSellingModelOnMarketPriceProperties {
  brand: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  hp: number;
  model: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  selling_price: number;
}

export interface PvmClickSalesVideoPlayButtonProperties {
  video_title: string;
}

export interface PvmClickSameBrandModelOnMarketPriceProperties {
  brand: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  highest_price: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  hp: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  lowest_price: number;
  model: string;
}

export interface PvmClickSearchFieldButtonProperties {
  text?: string;
  total?: string;
}

export interface PvmClickSellMachineButtonProperties {
  buttonType: string;
  page_type?: string;
}

export interface PvmClickSellMachineEditButtonProperties {
  id?: string;
  type: string;
}

export interface PvmClickSellSameModelOnMarketPriceProperties {
  brand: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  highest_price: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  hp: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  lowest_price: number;
  model: string;
}

export interface PvmClickSellTractorButtonProperties {
  page_type?: string;
  position?: string;
}

export interface PvmClickSellTractorNextButtonProperties {
  status?: string;
  title: string;
  type: string;
}

export interface PvmClickSellTractorPrevButtonProperties {
  title?: string;
}

export interface PvmClickSellTractorSignupProperties {
  type: string;
}

export interface PvmClickSellTractorSignupCancelProperties {
  type: string;
}

export interface PvmClickSendManagedFarmTaskInfoButtonProperties {
  field_owner_name: string;
  field_owner_phone_number: string;
  task_title: string;
}

export interface PvmClickSetAlarmProperties {
  page_type?: string;
}

export interface PvmClickSetAlarmModalCloseProperties {
  page_type?: string;
}

export interface PvmClickSimilarPsModelOnMarketPriceProperties {
  brand: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  highest_price: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  hp: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  lowest_price: number;
  model: string;
}

export interface PvmClickSubsidyBannerProperties {
  banner_id: string;
  banner_title: string;
  city: string;
  state: string;
}

export interface PvmClickSubsidyCardProperties {
  city: string;
  click_type: string;
  state: string;
  subsidy_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subsidy_tag_ids: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subsidy_tag_names: string[];
  subsidy_title: string;
}

export interface PvmClickSubsidyCategoryTabProperties {
  subsidy_category: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subsidy_tag_ids: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subsidy_tag_names: string[];
}

export interface PvmClickSubsidyInquiryButtonProperties {
  city: string;
  state: string;
  subsidy_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subsidy_tag_ids: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subsidy_tag_names: string[];
  subsidy_title: string;
}

export interface PvmClickSubsidyLocationFilterProperties {
  city: string;
  state: string;
}

export interface PvmClickSubsidySortFilterProperties {
  sort_type: string;
}

export interface PvmClickTractorPokingCardProperties {
  title?: string;
}

export interface PvmClickViewBrandMarketPriceProperties {
  title?: string;
}

export interface PvmCloseMarketPriceFilterModalProperties {
  is_auto_opened?: boolean;
}

export interface PvmCompleteAddFavoriteCropProperties {
  cultivar: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  wholesale_markets: string[];
}

export interface PvmCompleteBumpProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  bump_times: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  days_since_last_bump?: number;
  is_auto_bumped: boolean;
  product_id: string;
}

export interface PvmCropDetailMarketFilterChangeProperties {
  market: string;
}

export interface PvmCropListMarketFilterChangeProperties {
  market: string;
}

export interface PvmDeleteFavoriteCropProperties {
  cultivar: string;
}

export interface PvmDeleteManagedFarmTaskProperties {
  task_start_date: string;
  task_title: string;
}

export interface PvmEditSellMachineCompleteProperties {
  id?: string;
  type: string;
}

export interface PvmEnterOwnTractorImageUploadPageProperties {
  from: string;
}

export interface PvmFinishManageFarmFormProperties {
  check_point: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  recommended_check_point: string[];
}

export interface PvmGoNextPageManagedFarmFieldOwnerProperties {
  field_address?: string;
  field_owner_name: string;
  field_owner_phone_number: string;
}

export interface PvmGoNextPageManagedFarmTaskInfoProperties {
  crop_type: string;
  equipment: string;
  task_type: string;
}

export interface PvmGoNextPageManagedFarmTaskScheduleProperties {
  end_date: string;
  start_date: string;
}

export interface PvmOauthLoginCompletedProperties {
  need_to_sign_up: boolean;
}

export interface PvmPokeFeedbackCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  rating?: number;
}

export interface PvmProductInquiryProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  manufacturedYear?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  operationTime?: number;
  page_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  ps?: number;
  title?: string;
  type: string;
}

export interface PvmSearchMarketPriceProperties {
  search_keyword: string;
}

export interface PvmSearchMarketPriceAccuracyEvaluatedProperties {
  search_keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  search_result: string[];
}

export interface PvmSellTractorCompleteProperties {
  isLoggedIn: boolean;
  type: string;
}

export interface PvmSwipeProductPhotoProperties {
  direction: string;
  image_number: string;
  mode: string;
  page_type?: string;
  product_code: string;
  product_title: string;
  user_type?: string;
}

export interface TestEvent1Properties {
  id?: string;
  title?: string;
}

export interface TestEvent2Properties {
  "버튼 이름": string;
  "에러 내용": string;
}

export interface Properties {
  "접속 시도한 페이지 URL": string;
}

export interface AbProperties {
  "테스트 내용": string;
}

export interface Properties {
  "OS 정보"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "전화 번호"?: number;
  "접속 환경"?: string;
}

export interface Properties {
  "버튼 이름": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  page_type?: string;
  "매물 코드": string;
}

export interface Properties {
  page_type?: string;
  "매물 코드": string;
}

export interface Properties {
  page_type?: string;
  "매물 코드": string;
}

export interface Properties {
  page_type?: string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "매물 코드": string;
}

export interface Properties {
  "PDP 매물 분류": string;
  "PDP 매물 코드": string;
  "매물 분류": string;
  "매물 코드": string;
}

export interface Properties {
  "PDP 매물 분류": string;
  "PDP 매물 코드": string;
  "매물 분류": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 분류": string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  page_type?: string;
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  page_type?: string;
  "게시글 제목": string;
  "매물 코드": string;
}

export interface Properties {
  "서베이 이름": string;
}

export interface Properties {
  type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "미완료 페이지 번호"?: number;
  "서베이 이름": string;
}

export interface Properties {
  "에러 내용": string;
  "에러 종류": string;
  "에러가 발생한 URL": string;
}

export interface Properties {
  page_type?: string;
}

export interface Properties {
  "유저 ID": string;
}

export interface Properties {
  "유저 ID": string;
}

export interface Properties {
  "매물 코드": string;
}

export interface Properties {
  "유저 ID": string;
}

export interface Properties {
  "게시글 제목": string;
}

export interface Properties {
  "매물 분류": string;
  "매물 코드": string;
}

export interface Properties {
  "버튼 이름": string;
}

export interface Properties {
  "캐러셀 정보"?: string;
}

export interface Properties {
  "매물 코드": string;
}

export interface Properties {
  "매물 코드": string;
}

export interface Properties {
  "매물 코드": string;
}

export interface Properties {
  "유저 ID": string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmChangeManagedFarmTaskStatus implements BaseEvent {
  event_type = 'pvm_change_managed_farm_task_status';

  constructor(
    public event_properties: PvmChangeManagedFarmTaskStatusProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickAddPriceOnSellTractorSellingPricePage implements BaseEvent {
  event_type = 'pvm_click_add_price_on_sell_tractor_selling_price_page';

  constructor(
    public event_properties: PvmClickAddPriceOnSellTractorSellingPricePageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickApplyPriceOnSellTractorSellingPricePage implements BaseEvent {
  event_type = 'pvm_click_apply_price_on_sell_tractor_selling_price_page';

  constructor(
    public event_properties: PvmClickApplyPriceOnSellTractorSellingPricePageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickAppschemeAosDownloadButton implements BaseEvent {
  event_type = 'pvm_click_appscheme_aos_download_button';
}

export class PvmClickAppschemeBrowserViewButton implements BaseEvent {
  event_type = 'pvm_click_appscheme_browser_view_button';
}

export class PvmClickAppschemeIosDownloadButton implements BaseEvent {
  event_type = 'pvm_click_appscheme_ios_download_button';
}

export class PvmClickBumpAlreadyBumpModalButton implements BaseEvent {
  event_type = 'pvm_click_bump_already_bump_modal_button';
}

export class PvmClickBumpButtonInMyPage implements BaseEvent {
  event_type = 'pvm_click_bump_button_in_my_page';

  constructor(
    public event_properties: PvmClickBumpButtonInMyPageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickBumpButtonInOdp implements BaseEvent {
  event_type = 'pvm_click_bump_button_in_odp';

  constructor(
    public event_properties: PvmClickBumpButtonInOdpProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickBumpOncePerDayModalButton implements BaseEvent {
  event_type = 'pvm_click_bump_once_per_day_modal_button';
}

export class PvmClickBumpUsedAllAllottedAtteptsModalButton implements BaseEvent {
  event_type = 'pvm_click_bump_used_all_allotted_attepts_modal_button';
}

export class PvmClickCancelPokeButton implements BaseEvent {
  event_type = 'pvm_click_cancel_poke_button';
}

export class PvmClickContinueFromTempSaveButton implements BaseEvent {
  event_type = 'pvm_click_continue_from_temp_save_button';
}

export class PvmClickCropAccordionToggle implements BaseEvent {
  event_type = 'pvm_click_crop_accordion_toggle';

  constructor(
    public event_properties: PvmClickCropAccordionToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickCropCardInFavoriteCrop implements BaseEvent {
  event_type = 'pvm_click_crop_card_in_favorite_crop';

  constructor(
    public event_properties: PvmClickCropCardInFavoriteCropProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickCropCardInWholesaleMarket implements BaseEvent {
  event_type = 'pvm_click_crop_card_in_wholesale_market';

  constructor(
    public event_properties: PvmClickCropCardInWholesaleMarketProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickCropDetailShareButton implements BaseEvent {
  event_type = 'pvm_click_crop_detail_share_button';

  constructor(
    public event_properties: PvmClickCropDetailShareButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickCropFavoriteButton implements BaseEvent {
  event_type = 'pvm_click_crop_favorite_button';

  constructor(
    public event_properties: PvmClickCropFavoriteButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickCropListSelectMarketButton implements BaseEvent {
  event_type = 'pvm_click_crop_list_select_market_button';
}

export class PvmClickCsVideoPlayButton implements BaseEvent {
  event_type = 'pvm_click_CS_video_play_button';

  constructor(
    public event_properties: PvmClickCsVideoPlayButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickEnrollManagedFarmTaskFab implements BaseEvent {
  event_type = 'pvm_click_enroll_managed_farm_task_fab';

  constructor(
    public event_properties: PvmClickEnrollManagedFarmTaskFabProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickEnrollmanagedFarmTaskButtonOnEmptySection implements BaseEvent {
  event_type = 'pvm_click_enrollmanaged_farm_task_button_on_empty_section';

  constructor(
    public event_properties: PvmClickEnrollmanagedFarmTaskButtonOnEmptySectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickEvent240509InquiryButton implements BaseEvent {
  event_type = 'pvm_click_event_240509_inquiry_button';
}

export class PvmClickEvent240509ModalCloseButton implements BaseEvent {
  event_type = 'pvm_click_event_240509_modal_close_button';
}

export class PvmClickFarmTaskRegisterButton implements BaseEvent {
  event_type = 'pvm_click_farm_task_register_button';

  constructor(
    public event_properties?: PvmClickFarmTaskRegisterButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickFilterBrandQuickButton implements BaseEvent {
  event_type = 'pvm_click_filter_brand_quick_button';

  constructor(
    public event_properties: PvmClickFilterBrandQuickButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickFilterControllerMenuButton implements BaseEvent {
  event_type = 'pvm_click_filter_controller_menu_button';

  constructor(
    public event_properties: PvmClickFilterControllerMenuButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickFilterControllerResetButton implements BaseEvent {
  event_type = 'pvm_click_filter_controller_reset_button';

  constructor(
    public event_properties: PvmClickFilterControllerResetButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickFilterControllerSubmitButton implements BaseEvent {
  event_type = 'pvm_click_filter_controller_submit_button';

  constructor(
    public event_properties: PvmClickFilterControllerSubmitButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickFilterIconButton implements BaseEvent {
  event_type = 'pvm_click_filter_icon_button';

  constructor(
    public event_properties: PvmClickFilterIconButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickFilterSelection implements BaseEvent {
  event_type = 'pvm_click_filter_selection';

  constructor(
    public event_properties: PvmClickFilterSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickGnbInputCancelButton implements BaseEvent {
  event_type = 'pvm_click_gnb_input_cancel_button';

  constructor(
    public event_properties: PvmClickGnbInputCancelButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickGnbSearchButton implements BaseEvent {
  event_type = 'pvm_click_gnb_search_button';
}

export class PvmClickGoToAutoCsPage implements BaseEvent {
  event_type = 'pvm_click_go_to_auto_CS_page';
}

export class PvmClickGoToAutoSalesPage implements BaseEvent {
  event_type = 'pvm_click_go_to_auto_sales_page';
}

export class PvmClickGoToEvent240509PageButton implements BaseEvent {
  event_type = 'pvm_click_go_to_event_240509_page_button';
}

export class PvmClickGoToManagedFarmTaskDetailPageButton implements BaseEvent {
  event_type = 'pvm_click_go_to_managed_farm_task_detail_page_button';

  constructor(
    public event_properties: PvmClickGoToManagedFarmTaskDetailPageButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickGoToMyManagedFarmTaskButton implements BaseEvent {
  event_type = 'pvm_click_go_to_my_managed_farm_task_button';
}

export class PvmClickGoToOlpPage implements BaseEvent {
  event_type = 'pvm_click_go_to_olp_page';

  constructor(
    public event_properties?: PvmClickGoToOlpPageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickGoToSearchFieldButton implements BaseEvent {
  event_type = 'pvm_click_go_to_search_field_button';
}

export class PvmClickGoToSellMachineEntryPage implements BaseEvent {
  event_type = 'pvm_click_go_to_sell_machine_entry_page';

  constructor(
    public event_properties: PvmClickGoToSellMachineEntryPageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHeaderGnbMypageButton implements BaseEvent {
  event_type = 'pvm_click_header_gnb_mypage_button';
}

export class PvmClickHomeCropSwiper implements BaseEvent {
  event_type = 'pvm_click_home_crop_swiper';

  constructor(
    public event_properties: PvmClickHomeCropSwiperProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomeLandingIcon implements BaseEvent {
  event_type = 'pvm_click_home_landing_icon';

  constructor(
    public event_properties?: PvmClickHomeLandingIconProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomeNewProductCard implements BaseEvent {
  event_type = 'pvm_click_home_new_product_card';

  constructor(
    public event_properties: PvmClickHomeNewProductCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomeNewProductInquiry implements BaseEvent {
  event_type = 'pvm_click_home_new_product_inquiry';

  constructor(
    public event_properties: PvmClickHomeNewProductInquiryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomePluvaShopButton implements BaseEvent {
  event_type = 'pvm_click_home_pluva_shop_button';
}

export class PvmClickHomeRecommendedNewProductCard implements BaseEvent {
  event_type = 'pvm_click_home_recommended_new_product_card';

  constructor(
    public event_properties: PvmClickHomeRecommendedNewProductCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomeRecommendedTab implements BaseEvent {
  event_type = 'pvm_click_home_recommended_tab';

  constructor(
    public event_properties?: PvmClickHomeRecommendedTabProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomeVideoPdpViewButton implements BaseEvent {
  event_type = 'pvm_click_home_video_pdp_view_button';

  constructor(
    public event_properties: PvmClickHomeVideoPdpViewButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickHomeVideoPlayButton implements BaseEvent {
  event_type = 'pvm_click_home_video_play_button';

  constructor(
    public event_properties: PvmClickHomeVideoPlayButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickIdpFab implements BaseEvent {
  event_type = 'pvm_click_idp_fab';

  constructor(
    public event_properties?: PvmClickIdpFabProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickInquiryIntroduceModalPhoneAppImage implements BaseEvent {
  event_type = 'pvm_click_inquiry_introduce_modal_phone_app_image';
}

export class PvmClickLoginButtonInOdpSuggestPriceProcess implements BaseEvent {
  event_type = 'pvm_click_login_button_in_odp_suggest_price_process';

  constructor(
    public event_properties: PvmClickLoginButtonInOdpSuggestPriceProcessProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickLoginForPoke implements BaseEvent {
  event_type = 'pvm_click_login_for_poke';
}

export class PvmClickMachineSpecificationsTab implements BaseEvent {
  event_type = 'pvm_click_machine_specifications_tab';
}

export class PvmClickMainCarousel implements BaseEvent {
  event_type = 'pvm_click_main_carousel';

  constructor(
    public event_properties?: PvmClickMainCarouselProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickManagedFarmButton implements BaseEvent {
  event_type = 'pvm_click_managed_farm_button';
}

export class PvmClickManagedFarmTaskStatusChangeButton implements BaseEvent {
  event_type = 'pvm_click_managed_farm_task_status_change_button';

  constructor(
    public event_properties: PvmClickManagedFarmTaskStatusChangeButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMangedFarmSimpleCall implements BaseEvent {
  event_type = 'pvm_click_manged_farm_simple_call';

  constructor(
    public event_properties: PvmClickMangedFarmSimpleCallProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMangedFarmSimpleSms implements BaseEvent {
  event_type = 'pvm_click_manged_farm_simple_sms';

  constructor(
    public event_properties: PvmClickMangedFarmSimpleSmsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceCard implements BaseEvent {
  event_type = 'pvm_click_market_price_card';

  constructor(
    public event_properties: PvmClickMarketPriceCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceDetailLoginButton implements BaseEvent {
  event_type = 'pvm_click_market_price_detail_login_button';

  constructor(
    public event_properties: PvmClickMarketPriceDetailLoginButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceDetailShareButton implements BaseEvent {
  event_type = 'pvm_click_market_price_detail_share_button';

  constructor(
    public event_properties: PvmClickMarketPriceDetailShareButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceEntryQuickSearch implements BaseEvent {
  event_type = 'pvm_click_market_price_entry_quick_search';
}

export class PvmClickMarketPriceFilterButton implements BaseEvent {
  event_type = 'pvm_click_market_price_filter_button';

  constructor(
    public event_properties: PvmClickMarketPriceFilterButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceFilterSubmit implements BaseEvent {
  event_type = 'pvm_click_market_price_filter_submit';

  constructor(
    public event_properties: PvmClickMarketPriceFilterSubmitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceFilterSuggestion implements BaseEvent {
  event_type = 'pvm_click_market_price_filter_suggestion';

  constructor(
    public event_properties?: PvmClickMarketPriceFilterSuggestionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceQuickRecommendation implements BaseEvent {
  event_type = 'pvm_click_market_price_quick_recommendation';

  constructor(
    public event_properties?: PvmClickMarketPriceQuickRecommendationProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMarketPriceRecommendedKeyword implements BaseEvent {
  event_type = 'pvm_click_market_price_recommended_keyword';

  constructor(
    public event_properties: PvmClickMarketPriceRecommendedKeywordProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMonthNavigatorButton implements BaseEvent {
  event_type = 'pvm_click_month_navigator_button';

  constructor(
    public event_properties: PvmClickMonthNavigatorButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMoreProductButton implements BaseEvent {
  event_type = 'pvm_click_more_product_button';

  constructor(
    public event_properties?: PvmClickMoreProductButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMpdpPremiumProduct implements BaseEvent {
  event_type = 'pvm_click_mpdp_premium_product';

  constructor(
    public event_properties?: PvmClickMpdpPremiumProductProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMyDeleteOwnTractor implements BaseEvent {
  event_type = 'pvm_click_my_delete_own_tractor';
}

export class PvmClickMyDeleteOwnTractorDone implements BaseEvent {
  event_type = 'pvm_click_my_delete_own_tractor_done';

  constructor(
    public event_properties: PvmClickMyDeleteOwnTractorDoneProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMyEditOwnTractor implements BaseEvent {
  event_type = 'pvm_click_my_edit_own_tractor';
}

export class PvmClickMyMainConfirmPokeRequest implements BaseEvent {
  event_type = 'pvm_click_my_main_confirm_poke_request';
}

export class PvmClickMyMainOwnTractorCheck implements BaseEvent {
  event_type = 'pvm_click_my_main_own_tractor_check';
}

export class PvmClickMyOwnListConfirmPokeRequest implements BaseEvent {
  event_type = 'pvm_click_my_own_list_confirm_poke_request';

  constructor(
    public event_properties?: PvmClickMyOwnListConfirmPokeRequestProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMyOwnListMoreModalClose implements BaseEvent {
  event_type = 'pvm_click_my_own_list_more_modal_close';
}

export class PvmClickMyOwnListRequestModalClose implements BaseEvent {
  event_type = 'pvm_click_my_own_list_request_modal_close';
}

export class PvmClickMyOwnPublishedTab implements BaseEvent {
  event_type = 'pvm_click_my_own_published_tab';
}

export class PvmClickMyOwnUnpublishedTab implements BaseEvent {
  event_type = 'pvm_click_my_own_unpublished_tab';
}

export class PvmClickMySellMachineTab implements BaseEvent {
  event_type = 'pvm_click_my_sell_machine_tab';

  constructor(
    public event_properties?: PvmClickMySellMachineTabProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMySellOwnTractor implements BaseEvent {
  event_type = 'pvm_click_my_sell_own_tractor';

  constructor(
    public event_properties?: PvmClickMySellOwnTractorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickMyTogglePokeStatus implements BaseEvent {
  event_type = 'pvm_click_my_toggle_poke_status';

  constructor(
    public event_properties?: PvmClickMyTogglePokeStatusProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNdpPluvaTractors implements BaseEvent {
  event_type = 'pvm_click_ndp_pluva_tractors';

  constructor(
    public event_properties?: PvmClickNdpPluvaTractorsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNdpUserSellTractors implements BaseEvent {
  event_type = 'pvm_click_ndp_user_sell_tractors';

  constructor(
    public event_properties?: PvmClickNdpUserSellTractorsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNewProductDetailCard implements BaseEvent {
  event_type = 'pvm_click_new_product_detail_card';

  constructor(
    public event_properties: PvmClickNewProductDetailCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNewProductImage implements BaseEvent {
  event_type = 'pvm_click_new_product_image';

  constructor(
    public event_properties?: PvmClickNewProductImageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNewProductInquiry implements BaseEvent {
  event_type = 'pvm_click_new_product_inquiry';

  constructor(
    public event_properties: PvmClickNewProductInquiryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNewProductPreviewCard implements BaseEvent {
  event_type = 'pvm_click_new_product_preview_card';

  constructor(
    public event_properties: PvmClickNewProductPreviewCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickNewProductVideo implements BaseEvent {
  event_type = 'pvm_click_new_product_video';

  constructor(
    public event_properties?: PvmClickNewProductVideoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOdpSellTractorButton implements BaseEvent {
  event_type = 'pvm_click_odp_sell_tractor_button';
}

export class PvmClickOdpSuggestPriceButton implements BaseEvent {
  event_type = 'pvm_click_odp_suggest_price_button';

  constructor(
    public event_properties: PvmClickOdpSuggestPriceButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOdpSuggestPriceModalConfirmButton implements BaseEvent {
  event_type = 'pvm_click_odp_suggest_price_modal_confirm_button';

  constructor(
    public event_properties: PvmClickOdpSuggestPriceModalConfirmButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOlpOnSaleOnlyButton implements BaseEvent {
  event_type = 'pvm_click_olp_on_sale_only_button';

  constructor(
    public event_properties: PvmClickOlpOnSaleOnlyButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOlpProductFilterButton implements BaseEvent {
  event_type = 'pvm_click_olp_product_filter_button';

  constructor(
    public event_properties: PvmClickOlpProductFilterButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOlpTab implements BaseEvent {
  event_type = 'pvm_click_olp_tab';

  constructor(
    public event_properties: PvmClickOlpTabProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketDetailCardOnPlp implements BaseEvent {
  event_type = 'pvm_click_open_market_detail_card_on_plp';

  constructor(
    public event_properties: PvmClickOpenMarketDetailCardOnPlpProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchAutoCompleteKeyword implements BaseEvent {
  event_type = 'pvm_click_open_market_search_auto_complete_keyword';

  constructor(
    public event_properties: PvmClickOpenMarketSearchAutoCompleteKeywordProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchIcon implements BaseEvent {
  event_type = 'pvm_click_open_market_search_icon';

  constructor(
    public event_properties: PvmClickOpenMarketSearchIconProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchLandingButton implements BaseEvent {
  event_type = 'pvm_click_open_market_search_landing_button';

  constructor(
    public event_properties?: PvmClickOpenMarketSearchLandingButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchRecommendedSearchKeyword implements BaseEvent {
  event_type = 'pvm_click_open_market_search_recommended_search_keyword';

  constructor(
    public event_properties: PvmClickOpenMarketSearchRecommendedSearchKeywordProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchResultCard implements BaseEvent {
  event_type = 'pvm_click_open_market_search_result_card';

  constructor(
    public event_properties: PvmClickOpenMarketSearchResultCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchResultRetry implements BaseEvent {
  event_type = 'pvm_click_open_market_search_result_retry';

  constructor(
    public event_properties: PvmClickOpenMarketSearchResultRetryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOpenMarketSearchWatchByFilterButton implements BaseEvent {
  event_type = 'pvm_click_open_market_search_watch_by_filter_button';

  constructor(
    public event_properties: PvmClickOpenMarketSearchWatchByFilterButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickOptionDetailsButton implements BaseEvent {
  event_type = 'pvm_click_option_details_button';
}

export class PvmClickOwnTractorButton implements BaseEvent {
  event_type = 'pvm_click_own_tractor_button';
}

export class PvmClickOwnTractorImageUploadExit implements BaseEvent {
  event_type = 'pvm_click_own_tractor_image_upload_exit';
}

export class PvmClickOwnTractorImageUploadLater implements BaseEvent {
  event_type = 'pvm_click_own_tractor_image_upload_later';
}

export class PvmClickOwnTractorManage implements BaseEvent {
  event_type = 'pvm_click_own_tractor_manage';
}

export class PvmClickPdpProductPhoto implements BaseEvent {
  event_type = 'pvm_click_pdp_product_photo';

  constructor(
    public event_properties: PvmClickPdpProductPhotoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPdpToMarketPriceSearchResultButton implements BaseEvent {
  event_type = 'pvm_click_pdp_to_market_price_search_result_button';

  constructor(
    public event_properties?: PvmClickPdpToMarketPriceSearchResultButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPlpProductFilterButton implements BaseEvent {
  event_type = 'pvm_click_plp_product_filter_button';

  constructor(
    public event_properties: PvmClickPlpProductFilterButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPluvawayButton implements BaseEvent {
  event_type = 'pvm_click_pluvaway_button';

  constructor(
    public event_properties?: PvmClickPluvawayButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPoke implements BaseEvent {
  event_type = 'pvm_click_poke';

  constructor(
    public event_properties: PvmClickPokeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPokeCancel implements BaseEvent {
  event_type = 'pvm_click_poke_cancel';

  constructor(
    public event_properties?: PvmClickPokeCancelProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPokeCompleted implements BaseEvent {
  event_type = 'pvm_click_poke_completed';

  constructor(
    public event_properties: PvmClickPokeCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPokeFilterButton implements BaseEvent {
  event_type = 'pvm_click_poke_filter_button';

  constructor(
    public event_properties: PvmClickPokeFilterButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPokeFilterSubmit implements BaseEvent {
  event_type = 'pvm_click_poke_filter_submit';

  constructor(
    public event_properties: PvmClickPokeFilterSubmitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPokingDetailModalClose implements BaseEvent {
  event_type = 'pvm_click_poking_detail_modal_close';

  constructor(
    public event_properties?: PvmClickPokingDetailModalCloseProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPriceSuggestCard implements BaseEvent {
  event_type = 'pvm_click_price_suggest_card';

  constructor(
    public event_properties?: PvmClickPriceSuggestCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickPriceSuggestModalClose implements BaseEvent {
  event_type = 'pvm_click_price_suggest_modal_close';
}

export class PvmClickProductCardInSwiper implements BaseEvent {
  event_type = 'pvm_click_product_card_in_swiper';

  constructor(
    public event_properties?: PvmClickProductCardInSwiperProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickProductCardInstallmentButton implements BaseEvent {
  event_type = 'pvm_click_product_card_installment_button';

  constructor(
    public event_properties: PvmClickProductCardInstallmentButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickProductFilterOptionInput implements BaseEvent {
  event_type = 'pvm_click_product_filter_option_input';

  constructor(
    public event_properties: PvmClickProductFilterOptionInputProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickProductFullscreenPhotoArrowButton implements BaseEvent {
  event_type = 'pvm_click_product_fullscreen_photo_arrow_button';

  constructor(
    public event_properties: PvmClickProductFullscreenPhotoArrowButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickRealSellingModelOnMarketPrice implements BaseEvent {
  event_type = 'pvm_click_real_selling_model_on_market_price';

  constructor(
    public event_properties: PvmClickRealSellingModelOnMarketPriceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSalesVideoPlayButton implements BaseEvent {
  event_type = 'pvm_click_sales_video_play_button';

  constructor(
    public event_properties: PvmClickSalesVideoPlayButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSameBrandModelOnMarketPrice implements BaseEvent {
  event_type = 'pvm_click_same_brand_model_on_market_price';

  constructor(
    public event_properties: PvmClickSameBrandModelOnMarketPriceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSearchFieldButton implements BaseEvent {
  event_type = 'pvm_click_search_field_button';

  constructor(
    public event_properties?: PvmClickSearchFieldButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellMachineButton implements BaseEvent {
  event_type = 'pvm_click_sell_machine_button';

  constructor(
    public event_properties: PvmClickSellMachineButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellMachineEditButton implements BaseEvent {
  event_type = 'pvm_click_sell_machine_edit_button';

  constructor(
    public event_properties: PvmClickSellMachineEditButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellSameModelOnMarketPrice implements BaseEvent {
  event_type = 'pvm_click_sell_same_model_on_market_price';

  constructor(
    public event_properties: PvmClickSellSameModelOnMarketPriceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellTractorButton implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_button';

  constructor(
    public event_properties?: PvmClickSellTractorButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellTractorContinueWriting implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_continue_writing';
}

export class PvmClickSellTractorExitWithSave implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_exit_with_save';
}

export class PvmClickSellTractorNextButton implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_next_button';

  constructor(
    public event_properties: PvmClickSellTractorNextButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellTractorPrevButton implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_prev_button';

  constructor(
    public event_properties?: PvmClickSellTractorPrevButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellTractorQuickRegister implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_quick_register';
}

export class PvmClickSellTractorSignup implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_signup';

  constructor(
    public event_properties: PvmClickSellTractorSignupProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellTractorSignupCancel implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_signup_cancel';

  constructor(
    public event_properties: PvmClickSellTractorSignupCancelProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSellTractorTempOwnConfirm implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_temp_own_confirm';
}

export class PvmClickSellTractorTempOwnReject implements BaseEvent {
  event_type = 'pvm_click_sell_tractor_temp_own_reject';
}

export class PvmClickSendManagedFarmTaskInfoButton implements BaseEvent {
  event_type = 'pvm_click_send_managed_farm_task_info_button';

  constructor(
    public event_properties: PvmClickSendManagedFarmTaskInfoButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSetAlarm implements BaseEvent {
  event_type = 'pvm_click_set_alarm';

  constructor(
    public event_properties?: PvmClickSetAlarmProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSetAlarmModalClose implements BaseEvent {
  event_type = 'pvm_click_set_alarm_modal_close';

  constructor(
    public event_properties?: PvmClickSetAlarmModalCloseProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSimilarPsModelOnMarketPrice implements BaseEvent {
  event_type = 'pvm_click_similar_ps_model_on_market_price';

  constructor(
    public event_properties: PvmClickSimilarPsModelOnMarketPriceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSubsidyBanner implements BaseEvent {
  event_type = 'pvm_click_subsidy_banner';

  constructor(
    public event_properties: PvmClickSubsidyBannerProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSubsidyCard implements BaseEvent {
  event_type = 'pvm_click_subsidy_card';

  constructor(
    public event_properties: PvmClickSubsidyCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSubsidyCategoryTab implements BaseEvent {
  event_type = 'pvm_click_subsidy_category_tab';

  constructor(
    public event_properties: PvmClickSubsidyCategoryTabProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSubsidyContactlistButton implements BaseEvent {
  event_type = 'pvm_click_subsidy_contactlist_button';
}

export class PvmClickSubsidyInquiryButton implements BaseEvent {
  event_type = 'pvm_click_subsidy_inquiry_button';

  constructor(
    public event_properties: PvmClickSubsidyInquiryButtonProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSubsidyLocationFilter implements BaseEvent {
  event_type = 'pvm_click_subsidy_location_filter';

  constructor(
    public event_properties: PvmClickSubsidyLocationFilterProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickSubsidySortFilter implements BaseEvent {
  event_type = 'pvm_click_subsidy_sort_filter';

  constructor(
    public event_properties: PvmClickSubsidySortFilterProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickTractorPokingCard implements BaseEvent {
  event_type = 'pvm_click_tractor_poking_card';

  constructor(
    public event_properties?: PvmClickTractorPokingCardProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmClickViewBrandMarketPrice implements BaseEvent {
  event_type = 'pvm_click_view_brand_market_price';

  constructor(
    public event_properties?: PvmClickViewBrandMarketPriceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmCloseMarketPriceFilterModal implements BaseEvent {
  event_type = 'pvm_close_market_price_filter_modal';

  constructor(
    public event_properties?: PvmCloseMarketPriceFilterModalProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmCompleteAddFavoriteCrop implements BaseEvent {
  event_type = 'pvm_complete_add_favorite_crop';

  constructor(
    public event_properties: PvmCompleteAddFavoriteCropProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmCompleteBump implements BaseEvent {
  event_type = 'pvm_complete_bump';

  constructor(
    public event_properties: PvmCompleteBumpProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmCompleteOwnedThenSellCancel implements BaseEvent {
  event_type = 'pvm_complete_owned_then_sell_cancel';
}

export class PvmCompleteOwnedThenSellRegister implements BaseEvent {
  event_type = 'pvm_complete_owned_then_sell_register';
}

export class PvmCropDetailMarketFilterChange implements BaseEvent {
  event_type = 'pvm_crop_detail_market_filter_change';

  constructor(
    public event_properties: PvmCropDetailMarketFilterChangeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmCropListMarketFilterChange implements BaseEvent {
  event_type = 'pvm_crop_list_market_filter_change';

  constructor(
    public event_properties: PvmCropListMarketFilterChangeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmDeleteFavoriteCrop implements BaseEvent {
  event_type = 'pvm_delete_favorite_crop';

  constructor(
    public event_properties: PvmDeleteFavoriteCropProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmDeleteManagedFarmTask implements BaseEvent {
  event_type = 'pvm_delete_managed_farm_task';

  constructor(
    public event_properties: PvmDeleteManagedFarmTaskProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmEditSellMachineComplete implements BaseEvent {
  event_type = 'pvm_edit_sell_machine_complete';

  constructor(
    public event_properties: PvmEditSellMachineCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmEnterOwnTractorImageUploadPage implements BaseEvent {
  event_type = 'pvm_enter_own_tractor_image_upload_page';

  constructor(
    public event_properties: PvmEnterOwnTractorImageUploadPageProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmFinishManageFarmForm implements BaseEvent {
  event_type = 'pvm_finish_manage_farm_form';

  constructor(
    public event_properties: PvmFinishManageFarmFormProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmGoNextPageManagedFarmFieldOwner implements BaseEvent {
  event_type = 'pvm_go_next_page_managed_farm_field_owner';

  constructor(
    public event_properties: PvmGoNextPageManagedFarmFieldOwnerProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmGoNextPageManagedFarmTaskInfo implements BaseEvent {
  event_type = 'pvm_go_next_page_managed_farm_task_info';

  constructor(
    public event_properties: PvmGoNextPageManagedFarmTaskInfoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmGoNextPageManagedFarmTaskSchedule implements BaseEvent {
  event_type = 'pvm_go_next_page_managed_farm_task_schedule';

  constructor(
    public event_properties: PvmGoNextPageManagedFarmTaskScheduleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmLoginCompleted implements BaseEvent {
  event_type = 'pvm_login_completed';
}

export class PvmLogout implements BaseEvent {
  event_type = 'pvm_logout';
}

export class PvmOauthLoginCompleted implements BaseEvent {
  event_type = 'pvm_oauth_login_completed';

  constructor(
    public event_properties: PvmOauthLoginCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmOwnTractorComplete implements BaseEvent {
  event_type = 'pvm_own_tractor_complete';
}

export class PvmPageviewDownloadAppPage implements BaseEvent {
  event_type = 'pvm_pageview_download_app_page';
}

export class PvmPageviewPluvaAuto implements BaseEvent {
  event_type = 'pvm_pageview_pluva_auto';
}

export class PvmPageviewSellTractorEntry implements BaseEvent {
  event_type = 'pvm_pageview_sell_tractor_entry';
}

export class PvmPokeFeedbackCompleted implements BaseEvent {
  event_type = 'pvm_poke_feedback_completed';

  constructor(
    public event_properties?: PvmPokeFeedbackCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmProductInquiry implements BaseEvent {
  event_type = 'pvm_product_inquiry';

  constructor(
    public event_properties: PvmProductInquiryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmSearchMarketPrice implements BaseEvent {
  event_type = 'pvm_search_market_price';

  constructor(
    public event_properties: PvmSearchMarketPriceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmSearchMarketPriceAccuracyEvaluated implements BaseEvent {
  event_type = 'pvm_search_market_price_accuracy_evaluated';

  constructor(
    public event_properties: PvmSearchMarketPriceAccuracyEvaluatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmSellTractorComplete implements BaseEvent {
  event_type = 'pvm_sell_tractor_complete';

  constructor(
    public event_properties: PvmSellTractorCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmSetAdConsent implements BaseEvent {
  event_type = 'pvm_set_ad_consent';
}

export class PvmSignUp implements BaseEvent {
  event_type = 'pvm_sign_up';
}

export class PvmSubmitOwnTractorImage implements BaseEvent {
  event_type = 'pvm_submit_own_tractor_image';
}

export class PvmSwipeProductPhoto implements BaseEvent {
  event_type = 'pvm_swipe_product_photo';

  constructor(
    public event_properties: PvmSwipeProductPhotoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PvmUploadOwnTractorImage implements BaseEvent {
  event_type = 'pvm_upload_own_tractor_image';
}

export class TestEvent1 implements BaseEvent {
  event_type = 'test_event_1';

  constructor(
    public event_properties?: TestEvent1Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TestEvent2 implements BaseEvent {
  event_type = 'test_event_2';

  constructor(
    public event_properties: TestEvent2Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 기타낫파운드페이지조회 implements BaseEvent {
  event_type = '기타 - 낫파운드 페이지 조회';

  constructor(
    public event_properties: 기타낫파운드페이지조회Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 기타운영Ab테스트 implements BaseEvent {
  event_type = '기타운영 - AB 테스트';

  constructor(
    public event_properties: 기타운영Ab테스트Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 기타운영유저정보 implements BaseEvent {
  event_type = '기타운영 - 유저 정보';

  constructor(
    public event_properties?: 기타운영유저정보Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 네비게이터버튼클릭 implements BaseEvent {
  event_type = '네비게이터 버튼 클릭';

  constructor(
    public event_properties: 네비게이터버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마이공지사항페이지조회 implements BaseEvent {
  event_type = '마이 - 공지사항 페이지 조회';
}

export class 마이내정보수정페이지조회 implements BaseEvent {
  event_type = '마이 - 내 정보 수정 페이지 조회';
}

export class 마이마이페이지조회 implements BaseEvent {
  event_type = '마이 - 마이 페이지 조회';
}

export class 마이설정페이지조회 implements BaseEvent {
  event_type = '마이 - 설정 페이지 조회';
}

export class 마이애플로그인버튼클릭 implements BaseEvent {
  event_type = '마이 - 애플 로그인 버튼 클릭';
}

export class 마이이용약관페이지조회 implements BaseEvent {
  event_type = '마이 - 이용약관 페이지 조회';
}

export class 마이카카오로그인버튼클릭 implements BaseEvent {
  event_type = '마이 - 카카오 로그인 버튼 클릭';
}

export class 마켓내트랙터판매버튼클릭 implements BaseEvent {
  event_type = '마켓 - 내 트랙터 판매 버튼 클릭';
}

export class 마켓매물목록페이지가격더보기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 목록 페이지 가격 더보기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물목록페이지가격더보기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물목록페이지로그인하고할인된회원가격보기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 목록 페이지 로그인하고 할인된 회원가격 보기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물목록페이지로그인하고할인된회원가격보기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물목록페이지조회 implements BaseEvent {
  event_type = '마켓 - 매물 목록 페이지 조회';
}

export class 마켓매물상담버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상담 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상담버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지가격상담하기로그인모달닫기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 가격 상담하기 로그인 모달 닫기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지가격상담하기로그인모달닫기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지가격상담하기로그인모달로그인버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 가격 상담하기 로그인 모달 로그인 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지가격상담하기로그인모달로그인버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지가격상담하기전화번호모달남기기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 가격 상담하기 전화번호 모달 남기기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지가격상담하기전화번호모달남기기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지가격상담하기전화번호모달닫기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 가격 상담하기 전화번호 모달 닫기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지가격상담하기전화번호모달닫기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지구매절차버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 구매 절차 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지구매절차버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지농기계보험지원내용을확인해보세요버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 농기계 보험 지원 내용을 확인해보세요 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지농기계보험지원내용을확인해보세요버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지로그인하고할인된회원가격보기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 로그인하고 할인된 회원가격 보기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지로그인하고할인된회원가격보기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지매물모아보기매물클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 매물 모아보기 매물 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지매물모아보기매물클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지매물모아보기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 매물 모아보기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지매물모아보기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지요약정보버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 요약 정보 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지요약정보버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지융자확인에대한기본지식을알려드릴께요버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 융자확인에 대한 기본 지식을 알려드릴께요 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지융자확인에대한기본지식을알려드릴께요버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지점검및교체버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 점검 및 교체 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지점검및교체버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지제원및옵션버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 제원 및 옵션 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지제원및옵션버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지최종가와할부가격상세보기버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 최종가와 할부 가격 상세보기 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지최종가와할부가격상세보기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지플루바매물모아보기클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 플루바 매물 모아보기 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지플루바매물모아보기클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물상세페이지할부구매가궁금하신가요버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 상세 페이지 할부 구매가 궁금하신가요 버튼 클릭';

  constructor(
    public event_properties: 마켓매물상세페이지할부구매가궁금하신가요버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓매물알림버튼클릭 implements BaseEvent {
  event_type = '마켓 - 매물 알림 버튼 클릭';
}

export class 마켓오픈마켓매물목록페이지조회 implements BaseEvent {
  event_type = '마켓 - 오픈마켓 매물 목록 페이지 조회';
}

export class 마켓오픈마켓매물상세페이지조회 implements BaseEvent {
  event_type = '마켓 - 오픈마켓 매물 상세 페이지 조회';

  constructor(
    public event_properties: 마켓오픈마켓매물상세페이지조회Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓오픈마켓매물전화상담버튼클릭 implements BaseEvent {
  event_type = '마켓 - 오픈마켓 매물 전화 상담 버튼 클릭';

  constructor(
    public event_properties: 마켓오픈마켓매물전화상담버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓전체매물목록페이지조회 implements BaseEvent {
  event_type = '마켓 - 전체 매물 목록 페이지 조회';
}

export class 마켓파트너매물목록페이지조회 implements BaseEvent {
  event_type = '마켓 - 파트너 매물 목록 페이지 조회';
}

export class 마켓파트너매물상담권유버튼클릭 implements BaseEvent {
  event_type = '마켓 - 파트너 매물 상담 권유 버튼 클릭';

  constructor(
    public event_properties: 마켓파트너매물상담권유버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓파트너매물상세페이지조회 implements BaseEvent {
  event_type = '마켓 - 파트너 매물 상세 페이지 조회';

  constructor(
    public event_properties: 마켓파트너매물상세페이지조회Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓파트너매물전화상담버튼클릭 implements BaseEvent {
  event_type = '마켓 - 파트너 매물 전화 상담 버튼 클릭';

  constructor(
    public event_properties: 마켓파트너매물전화상담버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓파트너매물탭클릭 implements BaseEvent {
  event_type = '마켓 - 파트너 매물 탭 클릭';
}

export class 마켓플루바매물목록페이지조회 implements BaseEvent {
  event_type = '마켓 - 플루바 매물 목록 페이지 조회';
}

export class 마켓플루바매물상담권유버튼클릭 implements BaseEvent {
  event_type = '마켓 - 플루바 매물 상담 권유 버튼 클릭';

  constructor(
    public event_properties: 마켓플루바매물상담권유버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓플루바매물상세페이지조회 implements BaseEvent {
  event_type = '마켓 - 플루바 매물 상세 페이지 조회';

  constructor(
    public event_properties: 마켓플루바매물상세페이지조회Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓플루바매물전화상담버튼클릭 implements BaseEvent {
  event_type = '마켓 - 플루바 매물 전화 상담 버튼 클릭';

  constructor(
    public event_properties: 마켓플루바매물전화상담버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 마켓플루바매물탭클릭 implements BaseEvent {
  event_type = '마켓 - 플루바 매물 탭 클릭';
}

export class 마켓회원직거래탭클릭 implements BaseEvent {
  event_type = '마켓 - 회원 직거래 탭 클릭';
}

export class 서베이시작버튼클릭 implements BaseEvent {
  event_type = '서베이 - 시작 버튼 클릭';

  constructor(
    public event_properties: 서베이시작버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 서베이취소버튼클릭 implements BaseEvent {
  event_type = '서베이 - 취소 버튼 클릭';

  constructor(
    public event_properties: 서베이취소버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 에러발생 implements BaseEvent {
  event_type = '에러 발생';

  constructor(
    public event_properties: 에러발생Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 오토더자세히알아보기버튼클릭 implements BaseEvent {
  event_type = '오토 - 더 자세히 알아보기 버튼 클릭';
}

export class 오토최저가문의버튼클릭 implements BaseEvent {
  event_type = '오토 - 최저가 문의 버튼 클릭';
}

export class 오토플루바오토문의하기버튼클릭 implements BaseEvent {
  event_type = '오토 - 플루바 오토 문의하기 버튼 클릭';

  constructor(
    public event_properties?: 오토플루바오토문의하기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 유저회원가입완료 implements BaseEvent {
  event_type = '유저 - 회원가입 완료';
}

export class 이벤트값진년공유하기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 공유하기 버튼 클릭';

  constructor(
    public event_properties: 이벤트값진년공유하기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 이벤트값진년내트랙터팔기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 내 트랙터 팔기 버튼 클릭';
}

export class 이벤트값진년농협중고농기계구입자금안내버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 농협 중고 농기계 구입자금 안내 버튼 클릭';
}

export class 이벤트값진년마케팅수신동의버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 마케팅 수신 동의 버튼 클릭';

  constructor(
    public event_properties: 이벤트값진년마케팅수신동의버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 이벤트값진년마켓살펴보기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 마켓 살펴보기 버튼 클릭';
}

export class 이벤트값진년모달닫기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 모달 닫기 버튼 클릭';
}

export class 이벤트값진년모달보러가기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 모달 보러가기 버튼 클릭';
}

export class 이벤트값진년보러가기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 보러가기 버튼 클릭';

  constructor(
    public event_properties: 이벤트값진년보러가기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 이벤트값진년직거래바로가기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 직거래 바로 가기 버튼 클릭';
}

export class 이벤트값진년혜택받기버튼클릭 implements BaseEvent {
  event_type = '이벤트 - 값진년 혜택 받기 버튼 클릭';

  constructor(
    public event_properties: 이벤트값진년혜택받기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 정보목록페이지조회 implements BaseEvent {
  event_type = '정보 - 목록 페이지 조회';
}

export class 정보상세페이지조회 implements BaseEvent {
  event_type = '정보 - 상세 페이지 조회';

  constructor(
    public event_properties: 정보상세페이지조회Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈강력추천모아보기매물클릭 implements BaseEvent {
  event_type = '홈 - 강력 추천 모아보기 매물 클릭';

  constructor(
    public event_properties: 홈강력추천모아보기매물클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈내트랙터판매버튼클릭 implements BaseEvent {
  event_type = '홈 - 내 트랙터 판매 버튼 클릭';
}

export class 홈보유트랙터판매권유모달버튼클릭 implements BaseEvent {
  event_type = '홈 - 보유 트랙터 판매 권유 모달 버튼 클릭';

  constructor(
    public event_properties: 홈보유트랙터판매권유모달버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈상담하기버튼클릭 implements BaseEvent {
  event_type = '홈 - 상담하기 버튼 클릭';
}

export class 홈지원프로그램자세히보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 지원 프로그램 자세히 보기 버튼 클릭';
}

export class 홈캐러셀클릭 implements BaseEvent {
  event_type = '홈 - 캐러셀 클릭';

  constructor(
    public event_properties?: 홈캐러셀클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈트랙터구매버튼클릭 implements BaseEvent {
  event_type = '홈 - 트랙터 구매 버튼 클릭';
}

export class 홈파트너매물모아보기매물클릭 implements BaseEvent {
  event_type = '홈 - 파트너 매물 모아보기 매물 클릭';

  constructor(
    public event_properties: 홈파트너매물모아보기매물클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈파트너매물모아보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 파트너 매물 모아보기 버튼 클릭';
}

export class 홈플루바매물모아보기매물클릭 implements BaseEvent {
  event_type = '홈 - 플루바 매물 모아보기 매물 클릭';

  constructor(
    public event_properties: 홈플루바매물모아보기매물클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈플루바매물모아보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 플루바 매물 모아보기 버튼 클릭';
}

export class 홈플루바오토살펴보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 플루바 오토 살펴보기 버튼 클릭';
}

export class 홈할부배너매물보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 할부 배너 매물 보기 버튼 클릭';
}

export class 홈할부배너자세히보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 할부 배너 자세히 보기 버튼 클릭';
}

export class 홈홈페이지조회 implements BaseEvent {
  event_type = '홈 - 홈 페이지 조회';
}

export class 홈회원직거래매물모아보기매물클릭 implements BaseEvent {
  event_type = '홈 - 회원 직거래 매물 모아보기 매물 클릭';

  constructor(
    public event_properties: 홈회원직거래매물모아보기매물클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈회원직거래매물모아보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 회원 직거래 매물 모아보기 버튼 클릭';
}

export class 홈회원직거래배너매물보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 회원 직거래 배너 매물 보기 버튼 클릭';
}

export class 홈회원직거래배너자세히보기버튼클릭 implements BaseEvent {
  event_type = '홈 - 회원 직거래 배너 자세히 보기 버튼 클릭';
}

export class 홈회원가확인하기버튼클릭 implements BaseEvent {
  event_type = '홈 - 회원가 확인하기 버튼 클릭';

  constructor(
    public event_properties: 홈회원가확인하기버튼클릭Properties,
  ) {
    this.event_properties = event_properties;
  }
}

export class 홈회원가입버튼클릭 implements BaseEvent {
  event_type = '홈 - 회원가입 버튼 클릭';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * pvm_change_managed_farm_task_status
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_change_managed_farm_task_status)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. changed_status)
   * @param options Amplitude event options.
   */
  pvmChangeManagedFarmTaskStatus(
    properties: PvmChangeManagedFarmTaskStatusProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmChangeManagedFarmTaskStatus(properties), options);
  }

  /**
   * pvm_click_add_price_on_sell_tractor_selling_price_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_add_price_on_sell_tractor_selling_price_page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. added_amount)
   * @param options Amplitude event options.
   */
  pvmClickAddPriceOnSellTractorSellingPricePage(
    properties: PvmClickAddPriceOnSellTractorSellingPricePageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickAddPriceOnSellTractorSellingPricePage(properties), options);
  }

  /**
   * pvm_click_apply_price_on_sell_tractor_selling_price_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_apply_price_on_sell_tractor_selling_price_page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickApplyPriceOnSellTractorSellingPricePage(
    properties: PvmClickApplyPriceOnSellTractorSellingPricePageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickApplyPriceOnSellTractorSellingPricePage(properties), options);
  }

  /**
   * pvm_click_appscheme_aos_download_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_appscheme_aos_download_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickAppschemeAosDownloadButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickAppschemeAosDownloadButton(), options);
  }

  /**
   * pvm_click_appscheme_browser_view_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_appscheme_browser_view_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickAppschemeBrowserViewButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickAppschemeBrowserViewButton(), options);
  }

  /**
   * pvm_click_appscheme_ios_download_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_appscheme_ios_download_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickAppschemeIosDownloadButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickAppschemeIosDownloadButton(), options);
  }

  /**
   * pvm_click_bump_already_bump_modal_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_bump_already_bump_modal_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickBumpAlreadyBumpModalButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickBumpAlreadyBumpModalButton(), options);
  }

  /**
   * pvm_click_bump_button_in_my_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_bump_button_in_my_page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. index_in_list)
   * @param options Amplitude event options.
   */
  pvmClickBumpButtonInMyPage(
    properties: PvmClickBumpButtonInMyPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickBumpButtonInMyPage(properties), options);
  }

  /**
   * pvm_click_bump_button_in_odp
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_bump_button_in_odp)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. product_id)
   * @param options Amplitude event options.
   */
  pvmClickBumpButtonInOdp(
    properties: PvmClickBumpButtonInOdpProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickBumpButtonInOdp(properties), options);
  }

  /**
   * pvm_click_bump_once_per_day_modal_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_bump_once_per_day_modal_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickBumpOncePerDayModalButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickBumpOncePerDayModalButton(), options);
  }

  /**
   * pvm_click_bump_used_all_allotted_attepts_modal_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_bump_used_all_allotted_attepts_modal_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickBumpUsedAllAllottedAtteptsModalButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickBumpUsedAllAllottedAtteptsModalButton(), options);
  }

  /**
   * pvm_click_cancel_poke_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_cancel_poke_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickCancelPokeButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCancelPokeButton(), options);
  }

  /**
   * pvm_click_continue_from_temp_save_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_continue_from_temp_save_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickContinueFromTempSaveButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickContinueFromTempSaveButton(), options);
  }

  /**
   * pvm_click_crop_accordion_toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_crop_accordion_toggle)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  pvmClickCropAccordionToggle(
    properties: PvmClickCropAccordionToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCropAccordionToggle(properties), options);
  }

  /**
   * pvm_click_crop_card_in_favorite_crop
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_crop_card_in_favorite_crop)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cultivar)
   * @param options Amplitude event options.
   */
  pvmClickCropCardInFavoriteCrop(
    properties: PvmClickCropCardInFavoriteCropProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCropCardInFavoriteCrop(properties), options);
  }

  /**
   * pvm_click_crop_card_in_wholesale_market
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_crop_card_in_wholesale_market)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cultivar)
   * @param options Amplitude event options.
   */
  pvmClickCropCardInWholesaleMarket(
    properties: PvmClickCropCardInWholesaleMarketProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCropCardInWholesaleMarket(properties), options);
  }

  /**
   * pvm_click_crop_detail_share_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_crop_detail_share_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cultivar)
   * @param options Amplitude event options.
   */
  pvmClickCropDetailShareButton(
    properties: PvmClickCropDetailShareButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCropDetailShareButton(properties), options);
  }

  /**
   * pvm_click_crop_favorite_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_crop_favorite_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cultivar)
   * @param options Amplitude event options.
   */
  pvmClickCropFavoriteButton(
    properties: PvmClickCropFavoriteButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCropFavoriteButton(properties), options);
  }

  /**
   * pvm_click_crop_list_select_market_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_crop_list_select_market_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickCropListSelectMarketButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCropListSelectMarketButton(), options);
  }

  /**
   * pvm_click_CS_video_play_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_CS_video_play_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. video_title)
   * @param options Amplitude event options.
   */
  pvmClickCsVideoPlayButton(
    properties: PvmClickCsVideoPlayButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickCsVideoPlayButton(properties), options);
  }

  /**
   * pvm_click_enroll_managed_farm_task_fab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_enroll_managed_farm_task_fab)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. total_enrolled_tasks)
   * @param options Amplitude event options.
   */
  pvmClickEnrollManagedFarmTaskFab(
    properties: PvmClickEnrollManagedFarmTaskFabProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickEnrollManagedFarmTaskFab(properties), options);
  }

  /**
   * pvm_click_enrollmanaged_farm_task_button_on_empty_section
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_enrollmanaged_farm_task_button_on_empty_section)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. total_enrolled_tasks)
   * @param options Amplitude event options.
   */
  pvmClickEnrollmanagedFarmTaskButtonOnEmptySection(
    properties: PvmClickEnrollmanagedFarmTaskButtonOnEmptySectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickEnrollmanagedFarmTaskButtonOnEmptySection(properties), options);
  }

  /**
   * pvm_click_event_240509_inquiry_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_event_240509_inquiry_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickEvent240509InquiryButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickEvent240509InquiryButton(), options);
  }

  /**
   * pvm_click_event_240509_modal_close_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_event_240509_modal_close_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickEvent240509ModalCloseButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickEvent240509ModalCloseButton(), options);
  }

  /**
   * pvm_click_farm_task_register_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_farm_task_register_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. area_in_pyeong)
   * @param options Amplitude event options.
   */
  pvmClickFarmTaskRegisterButton(
    properties?: PvmClickFarmTaskRegisterButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFarmTaskRegisterButton(properties), options);
  }

  /**
   * pvm_click_filter_brand_quick_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_filter_brand_quick_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand_name)
   * @param options Amplitude event options.
   */
  pvmClickFilterBrandQuickButton(
    properties: PvmClickFilterBrandQuickButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFilterBrandQuickButton(properties), options);
  }

  /**
   * pvm_click_filter_controller_menu_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_filter_controller_menu_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_key)
   * @param options Amplitude event options.
   */
  pvmClickFilterControllerMenuButton(
    properties: PvmClickFilterControllerMenuButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFilterControllerMenuButton(properties), options);
  }

  /**
   * pvm_click_filter_controller_reset_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_filter_controller_reset_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  pvmClickFilterControllerResetButton(
    properties: PvmClickFilterControllerResetButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFilterControllerResetButton(properties), options);
  }

  /**
   * pvm_click_filter_controller_submit_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_filter_controller_submit_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  pvmClickFilterControllerSubmitButton(
    properties: PvmClickFilterControllerSubmitButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFilterControllerSubmitButton(properties), options);
  }

  /**
   * pvm_click_filter_icon_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_filter_icon_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. button_type)
   * @param options Amplitude event options.
   */
  pvmClickFilterIconButton(
    properties: PvmClickFilterIconButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFilterIconButton(properties), options);
  }

  /**
   * pvm_click_filter_selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_filter_selection)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  pvmClickFilterSelection(
    properties: PvmClickFilterSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickFilterSelection(properties), options);
  }

  /**
   * pvm_click_gnb_input_cancel_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_gnb_input_cancel_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. search_keyword)
   * @param options Amplitude event options.
   */
  pvmClickGnbInputCancelButton(
    properties: PvmClickGnbInputCancelButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGnbInputCancelButton(properties), options);
  }

  /**
   * pvm_click_gnb_search_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_gnb_search_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickGnbSearchButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGnbSearchButton(), options);
  }

  /**
   * pvm_click_go_to_auto_CS_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_auto_CS_page)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickGoToAutoCsPage(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToAutoCsPage(), options);
  }

  /**
   * pvm_click_go_to_auto_sales_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_auto_sales_page)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickGoToAutoSalesPage(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToAutoSalesPage(), options);
  }

  /**
   * pvm_click_go_to_event_240509_page_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_event_240509_page_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickGoToEvent240509PageButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToEvent240509PageButton(), options);
  }

  /**
   * pvm_click_go_to_managed_farm_task_detail_page_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_managed_farm_task_detail_page_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. task_start_day)
   * @param options Amplitude event options.
   */
  pvmClickGoToManagedFarmTaskDetailPageButton(
    properties: PvmClickGoToManagedFarmTaskDetailPageButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToManagedFarmTaskDetailPageButton(properties), options);
  }

  /**
   * pvm_click_go_to_my_managed_farm_task_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_my_managed_farm_task_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickGoToMyManagedFarmTaskButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToMyManagedFarmTaskButton(), options);
  }

  /**
   * pvm_click_go_to_olp_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_olp_page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickGoToOlpPage(
    properties?: PvmClickGoToOlpPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToOlpPage(properties), options);
  }

  /**
   * pvm_click_go_to_search_field_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_search_field_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickGoToSearchFieldButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToSearchFieldButton(), options);
  }

  /**
   * pvm_click_go_to_sell_machine_entry_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_go_to_sell_machine_entry_page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. buttonType)
   * @param options Amplitude event options.
   */
  pvmClickGoToSellMachineEntryPage(
    properties: PvmClickGoToSellMachineEntryPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickGoToSellMachineEntryPage(properties), options);
  }

  /**
   * pvm_click_header_gnb_mypage_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_header_gnb_mypage_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickHeaderGnbMypageButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHeaderGnbMypageButton(), options);
  }

  /**
   * pvm_click_home_crop_swiper
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_crop_swiper)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cutivar)
   * @param options Amplitude event options.
   */
  pvmClickHomeCropSwiper(
    properties: PvmClickHomeCropSwiperProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeCropSwiper(properties), options);
  }

  /**
   * pvm_click_home_landing_icon
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_landing_icon)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickHomeLandingIcon(
    properties?: PvmClickHomeLandingIconProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeLandingIcon(properties), options);
  }

  /**
   * pvm_click_home_new_product_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_new_product_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickHomeNewProductCard(
    properties: PvmClickHomeNewProductCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeNewProductCard(properties), options);
  }

  /**
   * pvm_click_home_new_product_inquiry
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_new_product_inquiry)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickHomeNewProductInquiry(
    properties: PvmClickHomeNewProductInquiryProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeNewProductInquiry(properties), options);
  }

  /**
   * pvm_click_home_pluva_shop_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_pluva_shop_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickHomePluvaShopButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomePluvaShopButton(), options);
  }

  /**
   * pvm_click_home_recommended_new_product_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_recommended_new_product_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickHomeRecommendedNewProductCard(
    properties: PvmClickHomeRecommendedNewProductCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeRecommendedNewProductCard(properties), options);
  }

  /**
   * pvm_click_home_recommended_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_recommended_tab)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickHomeRecommendedTab(
    properties?: PvmClickHomeRecommendedTabProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeRecommendedTab(properties), options);
  }

  /**
   * pvm_click_home_video_pdp_view_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_video_pdp_view_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  pvmClickHomeVideoPdpViewButton(
    properties: PvmClickHomeVideoPdpViewButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeVideoPdpViewButton(properties), options);
  }

  /**
   * pvm_click_home_video_play_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_home_video_play_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  pvmClickHomeVideoPlayButton(
    properties: PvmClickHomeVideoPlayButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickHomeVideoPlayButton(properties), options);
  }

  /**
   * pvm_click_idp_fab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_idp_fab)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickIdpFab(
    properties?: PvmClickIdpFabProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickIdpFab(properties), options);
  }

  /**
   * pvm_click_inquiry_introduce_modal_phone_app_image
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_inquiry_introduce_modal_phone_app_image)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickInquiryIntroduceModalPhoneAppImage(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickInquiryIntroduceModalPhoneAppImage(), options);
  }

  /**
   * pvm_click_login_button_in_odp_suggest_price_process
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_login_button_in_odp_suggest_price_process)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickLoginButtonInOdpSuggestPriceProcess(
    properties: PvmClickLoginButtonInOdpSuggestPriceProcessProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickLoginButtonInOdpSuggestPriceProcess(properties), options);
  }

  /**
   * pvm_click_login_for_poke
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_login_for_poke)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickLoginForPoke(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickLoginForPoke(), options);
  }

  /**
   * pvm_click_machine_specifications_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_machine_specifications_tab)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMachineSpecificationsTab(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMachineSpecificationsTab(), options);
  }

  /**
   * pvm_click_main_carousel
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_main_carousel)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. carousel_title)
   * @param options Amplitude event options.
   */
  pvmClickMainCarousel(
    properties?: PvmClickMainCarouselProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMainCarousel(properties), options);
  }

  /**
   * pvm_click_managed_farm_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_managed_farm_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickManagedFarmButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickManagedFarmButton(), options);
  }

  /**
   * pvm_click_managed_farm_task_status_change_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_managed_farm_task_status_change_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. task_start_day)
   * @param options Amplitude event options.
   */
  pvmClickManagedFarmTaskStatusChangeButton(
    properties: PvmClickManagedFarmTaskStatusChangeButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickManagedFarmTaskStatusChangeButton(properties), options);
  }

  /**
   * pvm_click_manged_farm_simple_call
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_manged_farm_simple_call)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_owner_name)
   * @param options Amplitude event options.
   */
  pvmClickMangedFarmSimpleCall(
    properties: PvmClickMangedFarmSimpleCallProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMangedFarmSimpleCall(properties), options);
  }

  /**
   * pvm_click_manged_farm_simple_sms
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_manged_farm_simple_sms)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_owner_name)
   * @param options Amplitude event options.
   */
  pvmClickMangedFarmSimpleSms(
    properties: PvmClickMangedFarmSimpleSmsProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMangedFarmSimpleSms(properties), options);
  }

  /**
   * pvm_click_market_price_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. engineOutputInPs)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceCard(
    properties: PvmClickMarketPriceCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceCard(properties), options);
  }

  /**
   * pvm_click_market_price_detail_login_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_detail_login_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. buttonType)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceDetailLoginButton(
    properties: PvmClickMarketPriceDetailLoginButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceDetailLoginButton(properties), options);
  }

  /**
   * pvm_click_market_price_detail_share_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_detail_share_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. model)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceDetailShareButton(
    properties: PvmClickMarketPriceDetailShareButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceDetailShareButton(properties), options);
  }

  /**
   * pvm_click_market_price_entry_quick_search
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_entry_quick_search)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceEntryQuickSearch(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceEntryQuickSearch(), options);
  }

  /**
   * pvm_click_market_price_filter_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_filter_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_key)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceFilterButton(
    properties: PvmClickMarketPriceFilterButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceFilterButton(properties), options);
  }

  /**
   * pvm_click_market_price_filter_submit
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_filter_submit)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_brands)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceFilterSubmit(
    properties: PvmClickMarketPriceFilterSubmitProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceFilterSubmit(properties), options);
  }

  /**
   * pvm_click_market_price_filter_suggestion
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_filter_suggestion)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. position)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceFilterSuggestion(
    properties?: PvmClickMarketPriceFilterSuggestionProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceFilterSuggestion(properties), options);
  }

  /**
   * pvm_click_market_price_quick_recommendation
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_quick_recommendation)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. position)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceQuickRecommendation(
    properties?: PvmClickMarketPriceQuickRecommendationProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceQuickRecommendation(properties), options);
  }

  /**
   * pvm_click_market_price_recommended_keyword
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_market_price_recommended_keyword)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. search_keyword)
   * @param options Amplitude event options.
   */
  pvmClickMarketPriceRecommendedKeyword(
    properties: PvmClickMarketPriceRecommendedKeywordProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMarketPriceRecommendedKeyword(properties), options);
  }

  /**
   * pvm_click_month_navigator_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_month_navigator_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. button_type)
   * @param options Amplitude event options.
   */
  pvmClickMonthNavigatorButton(
    properties: PvmClickMonthNavigatorButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMonthNavigatorButton(properties), options);
  }

  /**
   * pvm_click_more_product_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_more_product_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  pvmClickMoreProductButton(
    properties?: PvmClickMoreProductButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMoreProductButton(properties), options);
  }

  /**
   * pvm_click_mpdp_premium_product
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_mpdp_premium_product)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. sequence)
   * @param options Amplitude event options.
   */
  pvmClickMpdpPremiumProduct(
    properties?: PvmClickMpdpPremiumProductProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMpdpPremiumProduct(properties), options);
  }

  /**
   * pvm_click_my_delete_own_tractor
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_delete_own_tractor)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyDeleteOwnTractor(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyDeleteOwnTractor(), options);
  }

  /**
   * pvm_click_my_delete_own_tractor_done
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_delete_own_tractor_done)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickMyDeleteOwnTractorDone(
    properties: PvmClickMyDeleteOwnTractorDoneProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyDeleteOwnTractorDone(properties), options);
  }

  /**
   * pvm_click_my_edit_own_tractor
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_edit_own_tractor)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyEditOwnTractor(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyEditOwnTractor(), options);
  }

  /**
   * pvm_click_my_main_confirm_poke_request
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_main_confirm_poke_request)
   *
   * 이름 변경
   *
   * @param options Amplitude event options.
   */
  pvmClickMyMainConfirmPokeRequest(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyMainConfirmPokeRequest(), options);
  }

  /**
   * pvm_click_my_main_own_tractor_check
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_main_own_tractor_check)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyMainOwnTractorCheck(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyMainOwnTractorCheck(), options);
  }

  /**
   * pvm_click_my_own_list_confirm_poke_request
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_own_list_confirm_poke_request)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickMyOwnListConfirmPokeRequest(
    properties?: PvmClickMyOwnListConfirmPokeRequestProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyOwnListConfirmPokeRequest(properties), options);
  }

  /**
   * pvm_click_my_own_list_more_modal_close
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_own_list_more_modal_close)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyOwnListMoreModalClose(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyOwnListMoreModalClose(), options);
  }

  /**
   * pvm_click_my_own_list_request_modal_close
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_own_list_request_modal_close)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyOwnListRequestModalClose(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyOwnListRequestModalClose(), options);
  }

  /**
   * pvm_click_my_own_published_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_own_published_tab)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyOwnPublishedTab(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyOwnPublishedTab(), options);
  }

  /**
   * pvm_click_my_own_unpublished_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_own_unpublished_tab)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickMyOwnUnpublishedTab(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyOwnUnpublishedTab(), options);
  }

  /**
   * pvm_click_my_sell_machine_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_sell_machine_tab)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickMySellMachineTab(
    properties?: PvmClickMySellMachineTabProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMySellMachineTab(properties), options);
  }

  /**
   * pvm_click_my_sell_own_tractor
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_sell_own_tractor)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickMySellOwnTractor(
    properties?: PvmClickMySellOwnTractorProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMySellOwnTractor(properties), options);
  }

  /**
   * pvm_click_my_toggle_poke_status
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_my_toggle_poke_status)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. position)
   * @param options Amplitude event options.
   */
  pvmClickMyTogglePokeStatus(
    properties?: PvmClickMyTogglePokeStatusProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickMyTogglePokeStatus(properties), options);
  }

  /**
   * pvm_click_ndp_pluva_tractors
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_ndp_pluva_tractors)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNdpPluvaTractors(
    properties?: PvmClickNdpPluvaTractorsProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNdpPluvaTractors(properties), options);
  }

  /**
   * pvm_click_ndp_user_sell_tractors
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_ndp_user_sell_tractors)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNdpUserSellTractors(
    properties?: PvmClickNdpUserSellTractorsProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNdpUserSellTractors(properties), options);
  }

  /**
   * pvm_click_new_product_detail_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_new_product_detail_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNewProductDetailCard(
    properties: PvmClickNewProductDetailCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNewProductDetailCard(properties), options);
  }

  /**
   * pvm_click_new_product_image
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_new_product_image)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNewProductImage(
    properties?: PvmClickNewProductImageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNewProductImage(properties), options);
  }

  /**
   * pvm_click_new_product_inquiry
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_new_product_inquiry)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNewProductInquiry(
    properties: PvmClickNewProductInquiryProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNewProductInquiry(properties), options);
  }

  /**
   * pvm_click_new_product_preview_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_new_product_preview_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNewProductPreviewCard(
    properties: PvmClickNewProductPreviewCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNewProductPreviewCard(properties), options);
  }

  /**
   * pvm_click_new_product_video
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_new_product_video)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickNewProductVideo(
    properties?: PvmClickNewProductVideoProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickNewProductVideo(properties), options);
  }

  /**
   * pvm_click_odp_sell_tractor_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_odp_sell_tractor_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickOdpSellTractorButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOdpSellTractorButton(), options);
  }

  /**
   * pvm_click_odp_suggest_price_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_odp_suggest_price_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickOdpSuggestPriceButton(
    properties: PvmClickOdpSuggestPriceButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOdpSuggestPriceButton(properties), options);
  }

  /**
   * pvm_click_odp_suggest_price_modal_confirm_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_odp_suggest_price_modal_confirm_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickOdpSuggestPriceModalConfirmButton(
    properties: PvmClickOdpSuggestPriceModalConfirmButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOdpSuggestPriceModalConfirmButton(properties), options);
  }

  /**
   * pvm_click_olp_on_sale_only_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_olp_on_sale_only_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  pvmClickOlpOnSaleOnlyButton(
    properties: PvmClickOlpOnSaleOnlyButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOlpOnSaleOnlyButton(properties), options);
  }

  /**
   * pvm_click_olp_product_filter_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_olp_product_filter_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_key)
   * @param options Amplitude event options.
   */
  pvmClickOlpProductFilterButton(
    properties: PvmClickOlpProductFilterButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOlpProductFilterButton(properties), options);
  }

  /**
   * pvm_click_olp_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_olp_tab)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  pvmClickOlpTab(
    properties: PvmClickOlpTabProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOlpTab(properties), options);
  }

  /**
   * pvm_click_open_market_detail_card_on_plp
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_detail_card_on_plp)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. bump_times)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketDetailCardOnPlp(
    properties: PvmClickOpenMarketDetailCardOnPlpProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketDetailCardOnPlp(properties), options);
  }

  /**
   * pvm_click_open_market_search_auto_complete_keyword
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_auto_complete_keyword)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchAutoCompleteKeyword(
    properties: PvmClickOpenMarketSearchAutoCompleteKeywordProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchAutoCompleteKeyword(properties), options);
  }

  /**
   * pvm_click_open_market_search_icon
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_icon)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. typed_keyword)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchIcon(
    properties: PvmClickOpenMarketSearchIconProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchIcon(properties), options);
  }

  /**
   * pvm_click_open_market_search_landing_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_landing_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchLandingButton(
    properties?: PvmClickOpenMarketSearchLandingButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchLandingButton(properties), options);
  }

  /**
   * pvm_click_open_market_search_recommended_search_keyword
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_recommended_search_keyword)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchRecommendedSearchKeyword(
    properties: PvmClickOpenMarketSearchRecommendedSearchKeywordProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchRecommendedSearchKeyword(properties), options);
  }

  /**
   * pvm_click_open_market_search_result_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_result_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. code)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchResultCard(
    properties: PvmClickOpenMarketSearchResultCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchResultCard(properties), options);
  }

  /**
   * pvm_click_open_market_search_result_retry
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_result_retry)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. typed_keyword)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchResultRetry(
    properties: PvmClickOpenMarketSearchResultRetryProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchResultRetry(properties), options);
  }

  /**
   * pvm_click_open_market_search_watch_by_filter_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_open_market_search_watch_by_filter_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. button_name)
   * @param options Amplitude event options.
   */
  pvmClickOpenMarketSearchWatchByFilterButton(
    properties: PvmClickOpenMarketSearchWatchByFilterButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOpenMarketSearchWatchByFilterButton(properties), options);
  }

  /**
   * pvm_click_option_details_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_option_details_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickOptionDetailsButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOptionDetailsButton(), options);
  }

  /**
   * pvm_click_own_tractor_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_own_tractor_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickOwnTractorButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOwnTractorButton(), options);
  }

  /**
   * pvm_click_own_tractor_image_upload_exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_own_tractor_image_upload_exit)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickOwnTractorImageUploadExit(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOwnTractorImageUploadExit(), options);
  }

  /**
   * pvm_click_own_tractor_image_upload_later
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_own_tractor_image_upload_later)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickOwnTractorImageUploadLater(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOwnTractorImageUploadLater(), options);
  }

  /**
   * pvm_click_own_tractor_manage
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_own_tractor_manage)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickOwnTractorManage(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickOwnTractorManage(), options);
  }

  /**
   * pvm_click_pdp_product_photo
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_pdp_product_photo)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickPdpProductPhoto(
    properties: PvmClickPdpProductPhotoProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPdpProductPhoto(properties), options);
  }

  /**
   * pvm_click_pdp_to_market_price_search_result_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_pdp_to_market_price_search_result_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickPdpToMarketPriceSearchResultButton(
    properties?: PvmClickPdpToMarketPriceSearchResultButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPdpToMarketPriceSearchResultButton(properties), options);
  }

  /**
   * pvm_click_plp_product_filter_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_plp_product_filter_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_key)
   * @param options Amplitude event options.
   */
  pvmClickPlpProductFilterButton(
    properties: PvmClickPlpProductFilterButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPlpProductFilterButton(properties), options);
  }

  /**
   * pvm_click_pluvaway_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_pluvaway_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contact_method)
   * @param options Amplitude event options.
   */
  pvmClickPluvawayButton(
    properties?: PvmClickPluvawayButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPluvawayButton(properties), options);
  }

  /**
   * pvm_click_poke
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_poke)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. price)
   * @param options Amplitude event options.
   */
  pvmClickPoke(
    properties: PvmClickPokeProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPoke(properties), options);
  }

  /**
   * pvm_click_poke_cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_poke_cancel)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickPokeCancel(
    properties?: PvmClickPokeCancelProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPokeCancel(properties), options);
  }

  /**
   * pvm_click_poke_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_poke_completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. manufacturedYear)
   * @param options Amplitude event options.
   */
  pvmClickPokeCompleted(
    properties: PvmClickPokeCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPokeCompleted(properties), options);
  }

  /**
   * pvm_click_poke_filter_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_poke_filter_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_key)
   * @param options Amplitude event options.
   */
  pvmClickPokeFilterButton(
    properties: PvmClickPokeFilterButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPokeFilterButton(properties), options);
  }

  /**
   * pvm_click_poke_filter_submit
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_poke_filter_submit)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_brands)
   * @param options Amplitude event options.
   */
  pvmClickPokeFilterSubmit(
    properties: PvmClickPokeFilterSubmitProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPokeFilterSubmit(properties), options);
  }

  /**
   * pvm_click_poking_detail_modal_close
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_poking_detail_modal_close)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickPokingDetailModalClose(
    properties?: PvmClickPokingDetailModalCloseProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPokingDetailModalClose(properties), options);
  }

  /**
   * pvm_click_price_suggest_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_price_suggest_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. createAt)
   * @param options Amplitude event options.
   */
  pvmClickPriceSuggestCard(
    properties?: PvmClickPriceSuggestCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPriceSuggestCard(properties), options);
  }

  /**
   * pvm_click_price_suggest_modal_close
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_price_suggest_modal_close)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickPriceSuggestModalClose(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickPriceSuggestModalClose(), options);
  }

  /**
   * pvm_click_product_card_in_swiper
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_product_card_in_swiper)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  pvmClickProductCardInSwiper(
    properties?: PvmClickProductCardInSwiperProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickProductCardInSwiper(properties), options);
  }

  /**
   * pvm_click_product_card_installment_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_product_card_installment_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  pvmClickProductCardInstallmentButton(
    properties: PvmClickProductCardInstallmentButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickProductCardInstallmentButton(properties), options);
  }

  /**
   * pvm_click_product_filter_option_input
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_product_filter_option_input)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_key)
   * @param options Amplitude event options.
   */
  pvmClickProductFilterOptionInput(
    properties: PvmClickProductFilterOptionInputProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickProductFilterOptionInput(properties), options);
  }

  /**
   * pvm_click_product_fullscreen_photo_arrow_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_product_fullscreen_photo_arrow_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. direction)
   * @param options Amplitude event options.
   */
  pvmClickProductFullscreenPhotoArrowButton(
    properties: PvmClickProductFullscreenPhotoArrowButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickProductFullscreenPhotoArrowButton(properties), options);
  }

  /**
   * pvm_click_real_selling_model_on_market_price
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_real_selling_model_on_market_price)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickRealSellingModelOnMarketPrice(
    properties: PvmClickRealSellingModelOnMarketPriceProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickRealSellingModelOnMarketPrice(properties), options);
  }

  /**
   * pvm_click_sales_video_play_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sales_video_play_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. video_title)
   * @param options Amplitude event options.
   */
  pvmClickSalesVideoPlayButton(
    properties: PvmClickSalesVideoPlayButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSalesVideoPlayButton(properties), options);
  }

  /**
   * pvm_click_same_brand_model_on_market_price
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_same_brand_model_on_market_price)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickSameBrandModelOnMarketPrice(
    properties: PvmClickSameBrandModelOnMarketPriceProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSameBrandModelOnMarketPrice(properties), options);
  }

  /**
   * pvm_click_search_field_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_search_field_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. text)
   * @param options Amplitude event options.
   */
  pvmClickSearchFieldButton(
    properties?: PvmClickSearchFieldButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSearchFieldButton(properties), options);
  }

  /**
   * pvm_click_sell_machine_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_machine_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. buttonType)
   * @param options Amplitude event options.
   */
  pvmClickSellMachineButton(
    properties: PvmClickSellMachineButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellMachineButton(properties), options);
  }

  /**
   * pvm_click_sell_machine_edit_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_machine_edit_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmClickSellMachineEditButton(
    properties: PvmClickSellMachineEditButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellMachineEditButton(properties), options);
  }

  /**
   * pvm_click_sell_same_model_on_market_price
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_same_model_on_market_price)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickSellSameModelOnMarketPrice(
    properties: PvmClickSellSameModelOnMarketPriceProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellSameModelOnMarketPrice(properties), options);
  }

  /**
   * pvm_click_sell_tractor_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickSellTractorButton(
    properties?: PvmClickSellTractorButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorButton(properties), options);
  }

  /**
   * pvm_click_sell_tractor_continue_writing
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_continue_writing)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickSellTractorContinueWriting(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorContinueWriting(), options);
  }

  /**
   * pvm_click_sell_tractor_exit_with_save
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_exit_with_save)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickSellTractorExitWithSave(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorExitWithSave(), options);
  }

  /**
   * pvm_click_sell_tractor_next_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_next_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. status)
   * @param options Amplitude event options.
   */
  pvmClickSellTractorNextButton(
    properties: PvmClickSellTractorNextButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorNextButton(properties), options);
  }

  /**
   * pvm_click_sell_tractor_prev_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_prev_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickSellTractorPrevButton(
    properties?: PvmClickSellTractorPrevButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorPrevButton(properties), options);
  }

  /**
   * pvm_click_sell_tractor_quick_register
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_quick_register)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickSellTractorQuickRegister(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorQuickRegister(), options);
  }

  /**
   * pvm_click_sell_tractor_signup
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_signup)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  pvmClickSellTractorSignup(
    properties: PvmClickSellTractorSignupProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorSignup(properties), options);
  }

  /**
   * pvm_click_sell_tractor_signup_cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_signup_cancel)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  pvmClickSellTractorSignupCancel(
    properties: PvmClickSellTractorSignupCancelProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorSignupCancel(properties), options);
  }

  /**
   * pvm_click_sell_tractor_temp_own_confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_temp_own_confirm)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickSellTractorTempOwnConfirm(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorTempOwnConfirm(), options);
  }

  /**
   * pvm_click_sell_tractor_temp_own_reject
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_sell_tractor_temp_own_reject)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickSellTractorTempOwnReject(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSellTractorTempOwnReject(), options);
  }

  /**
   * pvm_click_send_managed_farm_task_info_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_send_managed_farm_task_info_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_owner_name)
   * @param options Amplitude event options.
   */
  pvmClickSendManagedFarmTaskInfoButton(
    properties: PvmClickSendManagedFarmTaskInfoButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSendManagedFarmTaskInfoButton(properties), options);
  }

  /**
   * pvm_click_set_alarm
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_set_alarm)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickSetAlarm(
    properties?: PvmClickSetAlarmProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSetAlarm(properties), options);
  }

  /**
   * pvm_click_set_alarm_modal_close
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_set_alarm_modal_close)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  pvmClickSetAlarmModalClose(
    properties?: PvmClickSetAlarmModalCloseProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSetAlarmModalClose(properties), options);
  }

  /**
   * pvm_click_similar_ps_model_on_market_price
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_similar_ps_model_on_market_price)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. brand)
   * @param options Amplitude event options.
   */
  pvmClickSimilarPsModelOnMarketPrice(
    properties: PvmClickSimilarPsModelOnMarketPriceProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSimilarPsModelOnMarketPrice(properties), options);
  }

  /**
   * pvm_click_subsidy_banner
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_banner)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. banner_id)
   * @param options Amplitude event options.
   */
  pvmClickSubsidyBanner(
    properties: PvmClickSubsidyBannerProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidyBanner(properties), options);
  }

  /**
   * pvm_click_subsidy_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. city)
   * @param options Amplitude event options.
   */
  pvmClickSubsidyCard(
    properties: PvmClickSubsidyCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidyCard(properties), options);
  }

  /**
   * pvm_click_subsidy_category_tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_category_tab)
   *
   * Owner: Jay Lee
   *
   * @param properties The event's properties (e.g. subsidy_category)
   * @param options Amplitude event options.
   */
  pvmClickSubsidyCategoryTab(
    properties: PvmClickSubsidyCategoryTabProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidyCategoryTab(properties), options);
  }

  /**
   * pvm_click_subsidy_contactlist_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_contactlist_button)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmClickSubsidyContactlistButton(
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidyContactlistButton(), options);
  }

  /**
   * pvm_click_subsidy_inquiry_button
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_inquiry_button)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. city)
   * @param options Amplitude event options.
   */
  pvmClickSubsidyInquiryButton(
    properties: PvmClickSubsidyInquiryButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidyInquiryButton(properties), options);
  }

  /**
   * pvm_click_subsidy_location_filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_location_filter)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. city)
   * @param options Amplitude event options.
   */
  pvmClickSubsidyLocationFilter(
    properties: PvmClickSubsidyLocationFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidyLocationFilter(properties), options);
  }

  /**
   * pvm_click_subsidy_sort_filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_subsidy_sort_filter)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. sort_type)
   * @param options Amplitude event options.
   */
  pvmClickSubsidySortFilter(
    properties: PvmClickSubsidySortFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickSubsidySortFilter(properties), options);
  }

  /**
   * pvm_click_tractor_poking_card
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_tractor_poking_card)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickTractorPokingCard(
    properties?: PvmClickTractorPokingCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickTractorPokingCard(properties), options);
  }

  /**
   * pvm_click_view_brand_market_price
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_click_view_brand_market_price)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  pvmClickViewBrandMarketPrice(
    properties?: PvmClickViewBrandMarketPriceProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmClickViewBrandMarketPrice(properties), options);
  }

  /**
   * pvm_close_market_price_filter_modal
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_close_market_price_filter_modal)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. is_auto_opened)
   * @param options Amplitude event options.
   */
  pvmCloseMarketPriceFilterModal(
    properties?: PvmCloseMarketPriceFilterModalProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmCloseMarketPriceFilterModal(properties), options);
  }

  /**
   * pvm_complete_add_favorite_crop
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_complete_add_favorite_crop)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cultivar)
   * @param options Amplitude event options.
   */
  pvmCompleteAddFavoriteCrop(
    properties: PvmCompleteAddFavoriteCropProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmCompleteAddFavoriteCrop(properties), options);
  }

  /**
   * pvm_complete_bump
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_complete_bump)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. bump_times)
   * @param options Amplitude event options.
   */
  pvmCompleteBump(
    properties: PvmCompleteBumpProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmCompleteBump(properties), options);
  }

  /**
   * pvm_complete_owned_then_sell_cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_complete_owned_then_sell_cancel)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmCompleteOwnedThenSellCancel(
    options?: EventOptions,
  ) {
    return this.track(new PvmCompleteOwnedThenSellCancel(), options);
  }

  /**
   * pvm_complete_owned_then_sell_register
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_complete_owned_then_sell_register)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmCompleteOwnedThenSellRegister(
    options?: EventOptions,
  ) {
    return this.track(new PvmCompleteOwnedThenSellRegister(), options);
  }

  /**
   * pvm_crop_detail_market_filter_change
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_crop_detail_market_filter_change)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. market)
   * @param options Amplitude event options.
   */
  pvmCropDetailMarketFilterChange(
    properties: PvmCropDetailMarketFilterChangeProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmCropDetailMarketFilterChange(properties), options);
  }

  /**
   * pvm_crop_list_market_filter_change
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_crop_list_market_filter_change)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. market)
   * @param options Amplitude event options.
   */
  pvmCropListMarketFilterChange(
    properties: PvmCropListMarketFilterChangeProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmCropListMarketFilterChange(properties), options);
  }

  /**
   * pvm_delete_favorite_crop
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_delete_favorite_crop)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. cultivar)
   * @param options Amplitude event options.
   */
  pvmDeleteFavoriteCrop(
    properties: PvmDeleteFavoriteCropProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmDeleteFavoriteCrop(properties), options);
  }

  /**
   * pvm_delete_managed_farm_task
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_delete_managed_farm_task)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. task_start_date)
   * @param options Amplitude event options.
   */
  pvmDeleteManagedFarmTask(
    properties: PvmDeleteManagedFarmTaskProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmDeleteManagedFarmTask(properties), options);
  }

  /**
   * pvm_edit_sell_machine_complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_edit_sell_machine_complete)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  pvmEditSellMachineComplete(
    properties: PvmEditSellMachineCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmEditSellMachineComplete(properties), options);
  }

  /**
   * pvm_enter_own_tractor_image_upload_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_enter_own_tractor_image_upload_page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. from)
   * @param options Amplitude event options.
   */
  pvmEnterOwnTractorImageUploadPage(
    properties: PvmEnterOwnTractorImageUploadPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmEnterOwnTractorImageUploadPage(properties), options);
  }

  /**
   * pvm_finish_manage_farm_form
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_finish_manage_farm_form)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. check_point)
   * @param options Amplitude event options.
   */
  pvmFinishManageFarmForm(
    properties: PvmFinishManageFarmFormProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmFinishManageFarmForm(properties), options);
  }

  /**
   * pvm_go_next_page_managed_farm_field_owner
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_go_next_page_managed_farm_field_owner)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field_address)
   * @param options Amplitude event options.
   */
  pvmGoNextPageManagedFarmFieldOwner(
    properties: PvmGoNextPageManagedFarmFieldOwnerProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmGoNextPageManagedFarmFieldOwner(properties), options);
  }

  /**
   * pvm_go_next_page_managed_farm_task_info
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_go_next_page_managed_farm_task_info)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. crop_type)
   * @param options Amplitude event options.
   */
  pvmGoNextPageManagedFarmTaskInfo(
    properties: PvmGoNextPageManagedFarmTaskInfoProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmGoNextPageManagedFarmTaskInfo(properties), options);
  }

  /**
   * pvm_go_next_page_managed_farm_task_schedule
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_go_next_page_managed_farm_task_schedule)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. end_date)
   * @param options Amplitude event options.
   */
  pvmGoNextPageManagedFarmTaskSchedule(
    properties: PvmGoNextPageManagedFarmTaskScheduleProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmGoNextPageManagedFarmTaskSchedule(properties), options);
  }

  /**
   * pvm_login_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_login_completed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmLoginCompleted(
    options?: EventOptions,
  ) {
    return this.track(new PvmLoginCompleted(), options);
  }

  /**
   * pvm_logout
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_logout)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmLogout(
    options?: EventOptions,
  ) {
    return this.track(new PvmLogout(), options);
  }

  /**
   * pvm_oauth_login_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_oauth_login_completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. need_to_sign_up)
   * @param options Amplitude event options.
   */
  pvmOauthLoginCompleted(
    properties: PvmOauthLoginCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmOauthLoginCompleted(properties), options);
  }

  /**
   * pvm_own_tractor_complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_own_tractor_complete)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmOwnTractorComplete(
    options?: EventOptions,
  ) {
    return this.track(new PvmOwnTractorComplete(), options);
  }

  /**
   * pvm_pageview_download_app_page
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_pageview_download_app_page)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmPageviewDownloadAppPage(
    options?: EventOptions,
  ) {
    return this.track(new PvmPageviewDownloadAppPage(), options);
  }

  /**
   * pvm_pageview_pluva_auto
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_pageview_pluva_auto)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmPageviewPluvaAuto(
    options?: EventOptions,
  ) {
    return this.track(new PvmPageviewPluvaAuto(), options);
  }

  /**
   * pvm_pageview_sell_tractor_entry
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_pageview_sell_tractor_entry)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmPageviewSellTractorEntry(
    options?: EventOptions,
  ) {
    return this.track(new PvmPageviewSellTractorEntry(), options);
  }

  /**
   * pvm_poke_feedback_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_poke_feedback_completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. rating)
   * @param options Amplitude event options.
   */
  pvmPokeFeedbackCompleted(
    properties?: PvmPokeFeedbackCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmPokeFeedbackCompleted(properties), options);
  }

  /**
   * pvm_product_inquiry
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_product_inquiry)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. manufacturedYear)
   * @param options Amplitude event options.
   */
  pvmProductInquiry(
    properties: PvmProductInquiryProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmProductInquiry(properties), options);
  }

  /**
   * pvm_search_market_price
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_search_market_price)
   *
   * ```
   * ```
   *
   * @param properties The event's properties (e.g. search_keyword)
   * @param options Amplitude event options.
   */
  pvmSearchMarketPrice(
    properties: PvmSearchMarketPriceProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmSearchMarketPrice(properties), options);
  }

  /**
   * pvm_search_market_price_accuracy_evaluated
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_search_market_price_accuracy_evaluated)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. search_keyword)
   * @param options Amplitude event options.
   */
  pvmSearchMarketPriceAccuracyEvaluated(
    properties: PvmSearchMarketPriceAccuracyEvaluatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmSearchMarketPriceAccuracyEvaluated(properties), options);
  }

  /**
   * pvm_sell_tractor_complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_sell_tractor_complete)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. isLoggedIn)
   * @param options Amplitude event options.
   */
  pvmSellTractorComplete(
    properties: PvmSellTractorCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmSellTractorComplete(properties), options);
  }

  /**
   * pvm_set_ad_consent
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_set_ad_consent)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmSetAdConsent(
    options?: EventOptions,
  ) {
    return this.track(new PvmSetAdConsent(), options);
  }

  /**
   * pvm_sign_up
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_sign_up)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmSignUp(
    options?: EventOptions,
  ) {
    return this.track(new PvmSignUp(), options);
  }

  /**
   * pvm_submit_own_tractor_image
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_submit_own_tractor_image)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmSubmitOwnTractorImage(
    options?: EventOptions,
  ) {
    return this.track(new PvmSubmitOwnTractorImage(), options);
  }

  /**
   * pvm_swipe_product_photo
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_swipe_product_photo)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. direction)
   * @param options Amplitude event options.
   */
  pvmSwipeProductPhoto(
    properties: PvmSwipeProductPhotoProperties,
    options?: EventOptions,
  ) {
    return this.track(new PvmSwipeProductPhoto(properties), options);
  }

  /**
   * pvm_upload_own_tractor_image
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/pvm_upload_own_tractor_image)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pvmUploadOwnTractorImage(
    options?: EventOptions,
  ) {
    return this.track(new PvmUploadOwnTractorImage(), options);
  }

  /**
   * test_event_1
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/test_event_1)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  testEvent1(
    properties?: TestEvent1Properties,
    options?: EventOptions,
  ) {
    return this.track(new TestEvent1(properties), options);
  }

  /**
   * test_event_2
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/test_event_2)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 버튼 이름)
   * @param options Amplitude event options.
   */
  testEvent2(
    properties: TestEvent2Properties,
    options?: EventOptions,
  ) {
    return this.track(new TestEvent2(properties), options);
  }

  /**
   * 기타 - 낫파운드 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EA%B8%B0%ED%83%80%20-%20%EB%82%AB%ED%8C%8C%EC%9A%B4%EB%93%9C%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 접속 시도한 페이지 URL)
   * @param options Amplitude event options.
   */
  기타낫파운드페이지조회(
    properties: 기타낫파운드페이지조회Properties,
    options?: EventOptions,
  ) {
    return this.track(new 기타낫파운드페이지조회(properties), options);
  }

  /**
   * 기타운영 - AB 테스트
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EA%B8%B0%ED%83%80%EC%9A%B4%EC%98%81%20-%20AB%20%ED%85%8C%EC%8A%A4%ED%8A%B8)
   *
   * Owner: Jonghoon Son
   *
   * @param properties The event's properties (e.g. 테스트 내용)
   * @param options Amplitude event options.
   */
  기타운영Ab테스트(
    properties: 기타운영Ab테스트Properties,
    options?: EventOptions,
  ) {
    return this.track(new 기타운영Ab테스트(properties), options);
  }

  /**
   * 기타운영 - 유저 정보
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EA%B8%B0%ED%83%80%EC%9A%B4%EC%98%81%20-%20%EC%9C%A0%EC%A0%80%20%EC%A0%95%EB%B3%B4)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. OS 정보)
   * @param options Amplitude event options.
   */
  기타운영유저정보(
    properties?: 기타운영유저정보Properties,
    options?: EventOptions,
  ) {
    return this.track(new 기타운영유저정보(properties), options);
  }

  /**
   * 네비게이터 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%84%A4%EB%B9%84%EA%B2%8C%EC%9D%B4%ED%84%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 버튼 이름)
   * @param options Amplitude event options.
   */
  네비게이터버튼클릭(
    properties: 네비게이터버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 네비게이터버튼클릭(properties), options);
  }

  /**
   * 마이 - 공지사항 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EA%B3%B5%EC%A7%80%EC%82%AC%ED%95%AD%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이공지사항페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마이공지사항페이지조회(), options);
  }

  /**
   * 마이 - 내 정보 수정 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EB%82%B4%20%EC%A0%95%EB%B3%B4%20%EC%88%98%EC%A0%95%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이내정보수정페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마이내정보수정페이지조회(), options);
  }

  /**
   * 마이 - 마이 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EB%A7%88%EC%9D%B4%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이마이페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마이마이페이지조회(), options);
  }

  /**
   * 마이 - 설정 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EC%84%A4%EC%A0%95%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이설정페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마이설정페이지조회(), options);
  }

  /**
   * 마이 - 애플 로그인 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EC%95%A0%ED%94%8C%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이애플로그인버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마이애플로그인버튼클릭(), options);
  }

  /**
   * 마이 - 이용약관 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EC%9D%B4%EC%9A%A9%EC%95%BD%EA%B4%80%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이이용약관페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마이이용약관페이지조회(), options);
  }

  /**
   * 마이 - 카카오 로그인 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%9D%B4%20-%20%EC%B9%B4%EC%B9%B4%EC%98%A4%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마이카카오로그인버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마이카카오로그인버튼클릭(), options);
  }

  /**
   * 마켓 - 내 트랙터 판매 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%82%B4%20%ED%8A%B8%EB%9E%99%ED%84%B0%20%ED%8C%90%EB%A7%A4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓내트랙터판매버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마켓내트랙터판매버튼클릭(), options);
  }

  /**
   * 마켓 - 매물 목록 페이지 가격 더보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EA%B0%80%EA%B2%A9%20%EB%8D%94%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물목록페이지가격더보기버튼클릭(
    properties: 마켓매물목록페이지가격더보기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물목록페이지가격더보기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 목록 페이지 로그인하고 할인된 회원가격 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%ED%95%98%EA%B3%A0%20%ED%95%A0%EC%9D%B8%EB%90%9C%20%ED%9A%8C%EC%9B%90%EA%B0%80%EA%B2%A9%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  마켓매물목록페이지로그인하고할인된회원가격보기버튼클릭(
    properties: 마켓매물목록페이지로그인하고할인된회원가격보기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물목록페이지로그인하고할인된회원가격보기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 목록 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓매물목록페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물목록페이지조회(), options);
  }

  /**
   * 마켓 - 매물 상담 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EB%8B%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상담버튼클릭(
    properties: 마켓매물상담버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상담버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 가격 상담하기 로그인 모달 닫기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EA%B0%80%EA%B2%A9%20%EC%83%81%EB%8B%B4%ED%95%98%EA%B8%B0%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%20%EB%AA%A8%EB%8B%AC%20%EB%8B%AB%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지가격상담하기로그인모달닫기버튼클릭(
    properties: 마켓매물상세페이지가격상담하기로그인모달닫기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지가격상담하기로그인모달닫기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 가격 상담하기 로그인 모달 로그인 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EA%B0%80%EA%B2%A9%20%EC%83%81%EB%8B%B4%ED%95%98%EA%B8%B0%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%20%EB%AA%A8%EB%8B%AC%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지가격상담하기로그인모달로그인버튼클릭(
    properties: 마켓매물상세페이지가격상담하기로그인모달로그인버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지가격상담하기로그인모달로그인버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 가격 상담하기 전화번호 모달 남기기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EA%B0%80%EA%B2%A9%20%EC%83%81%EB%8B%B4%ED%95%98%EA%B8%B0%20%EC%A0%84%ED%99%94%EB%B2%88%ED%98%B8%20%EB%AA%A8%EB%8B%AC%20%EB%82%A8%EA%B8%B0%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지가격상담하기전화번호모달남기기버튼클릭(
    properties: 마켓매물상세페이지가격상담하기전화번호모달남기기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지가격상담하기전화번호모달남기기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 가격 상담하기 전화번호 모달 닫기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EA%B0%80%EA%B2%A9%20%EC%83%81%EB%8B%B4%ED%95%98%EA%B8%B0%20%EC%A0%84%ED%99%94%EB%B2%88%ED%98%B8%20%EB%AA%A8%EB%8B%AC%20%EB%8B%AB%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지가격상담하기전화번호모달닫기버튼클릭(
    properties: 마켓매물상세페이지가격상담하기전화번호모달닫기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지가격상담하기전화번호모달닫기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 구매 절차 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EA%B5%AC%EB%A7%A4%20%EC%A0%88%EC%B0%A8%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지구매절차버튼클릭(
    properties: 마켓매물상세페이지구매절차버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지구매절차버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 농기계 보험 지원 내용을 확인해보세요 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EB%86%8D%EA%B8%B0%EA%B3%84%20%EB%B3%B4%ED%97%98%20%EC%A7%80%EC%9B%90%20%EB%82%B4%EC%9A%A9%EC%9D%84%20%ED%99%95%EC%9D%B8%ED%95%B4%EB%B3%B4%EC%84%B8%EC%9A%94%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지농기계보험지원내용을확인해보세요버튼클릭(
    properties: 마켓매물상세페이지농기계보험지원내용을확인해보세요버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지농기계보험지원내용을확인해보세요버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 로그인하고 할인된 회원가격 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%ED%95%98%EA%B3%A0%20%ED%95%A0%EC%9D%B8%EB%90%9C%20%ED%9A%8C%EC%9B%90%EA%B0%80%EA%B2%A9%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지로그인하고할인된회원가격보기버튼클릭(
    properties: 마켓매물상세페이지로그인하고할인된회원가격보기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지로그인하고할인된회원가격보기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 매물 모아보기 매물 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%A7%A4%EB%AC%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. PDP 매물 분류)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지매물모아보기매물클릭(
    properties: 마켓매물상세페이지매물모아보기매물클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지매물모아보기매물클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 매물 모아보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. PDP 매물 분류)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지매물모아보기버튼클릭(
    properties: 마켓매물상세페이지매물모아보기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지매물모아보기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 요약 정보 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%9A%94%EC%95%BD%20%EC%A0%95%EB%B3%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지요약정보버튼클릭(
    properties: 마켓매물상세페이지요약정보버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지요약정보버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 융자확인에 대한 기본 지식을 알려드릴께요 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%9C%B5%EC%9E%90%ED%99%95%EC%9D%B8%EC%97%90%20%EB%8C%80%ED%95%9C%20%EA%B8%B0%EB%B3%B8%20%EC%A7%80%EC%8B%9D%EC%9D%84%20%EC%95%8C%EB%A0%A4%EB%93%9C%EB%A6%B4%EA%BB%98%EC%9A%94%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지융자확인에대한기본지식을알려드릴께요버튼클릭(
    properties: 마켓매물상세페이지융자확인에대한기본지식을알려드릴께요버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지융자확인에대한기본지식을알려드릴께요버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 점검 및 교체 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A0%90%EA%B2%80%20%EB%B0%8F%20%EA%B5%90%EC%B2%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지점검및교체버튼클릭(
    properties: 마켓매물상세페이지점검및교체버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지점검및교체버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 제원 및 옵션 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A0%9C%EC%9B%90%20%EB%B0%8F%20%EC%98%B5%EC%85%98%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지제원및옵션버튼클릭(
    properties: 마켓매물상세페이지제원및옵션버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지제원및옵션버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 최종가와 할부 가격 상세보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%B5%9C%EC%A2%85%EA%B0%80%EC%99%80%20%ED%95%A0%EB%B6%80%20%EA%B0%80%EA%B2%A9%20%EC%83%81%EC%84%B8%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지최종가와할부가격상세보기버튼클릭(
    properties: 마켓매물상세페이지최종가와할부가격상세보기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지최종가와할부가격상세보기버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 플루바 매물 모아보기 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지플루바매물모아보기클릭(
    properties: 마켓매물상세페이지플루바매물모아보기클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지플루바매물모아보기클릭(properties), options);
  }

  /**
   * 마켓 - 매물 상세 페이지 할부 구매가 궁금하신가요 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%ED%95%A0%EB%B6%80%20%EA%B5%AC%EB%A7%A4%EA%B0%80%20%EA%B6%81%EA%B8%88%ED%95%98%EC%8B%A0%EA%B0%80%EC%9A%94%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓매물상세페이지할부구매가궁금하신가요버튼클릭(
    properties: 마켓매물상세페이지할부구매가궁금하신가요버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물상세페이지할부구매가궁금하신가요버튼클릭(properties), options);
  }

  /**
   * 마켓 - 매물 알림 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EB%A7%A4%EB%AC%BC%20%EC%95%8C%EB%A6%BC%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓매물알림버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마켓매물알림버튼클릭(), options);
  }

  /**
   * 마켓 - 오픈마켓 매물 목록 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EC%98%A4%ED%94%88%EB%A7%88%EC%BC%93%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓오픈마켓매물목록페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마켓오픈마켓매물목록페이지조회(), options);
  }

  /**
   * 마켓 - 오픈마켓 매물 상세 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EC%98%A4%ED%94%88%EB%A7%88%EC%BC%93%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓오픈마켓매물상세페이지조회(
    properties: 마켓오픈마켓매물상세페이지조회Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓오픈마켓매물상세페이지조회(properties), options);
  }

  /**
   * 마켓 - 오픈마켓 매물 전화 상담 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EC%98%A4%ED%94%88%EB%A7%88%EC%BC%93%20%EB%A7%A4%EB%AC%BC%20%EC%A0%84%ED%99%94%20%EC%83%81%EB%8B%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓오픈마켓매물전화상담버튼클릭(
    properties: 마켓오픈마켓매물전화상담버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓오픈마켓매물전화상담버튼클릭(properties), options);
  }

  /**
   * 마켓 - 전체 매물 목록 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%EC%A0%84%EC%B2%B4%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓전체매물목록페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마켓전체매물목록페이지조회(), options);
  }

  /**
   * 마켓 - 파트너 매물 목록 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마켓파트너매물목록페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마켓파트너매물목록페이지조회(), options);
  }

  /**
   * 마켓 - 파트너 매물 상담 권유 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EB%8B%B4%20%EA%B6%8C%EC%9C%A0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓파트너매물상담권유버튼클릭(
    properties: 마켓파트너매물상담권유버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓파트너매물상담권유버튼클릭(properties), options);
  }

  /**
   * 마켓 - 파트너 매물 상세 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓파트너매물상세페이지조회(
    properties: 마켓파트너매물상세페이지조회Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓파트너매물상세페이지조회(properties), options);
  }

  /**
   * 마켓 - 파트너 매물 전화 상담 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EC%A0%84%ED%99%94%20%EC%83%81%EB%8B%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  마켓파트너매물전화상담버튼클릭(
    properties: 마켓파트너매물전화상담버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓파트너매물전화상담버튼클릭(properties), options);
  }

  /**
   * 마켓 - 파트너 매물 탭 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%ED%83%AD%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓파트너매물탭클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마켓파트너매물탭클릭(), options);
  }

  /**
   * 마켓 - 플루바 매물 목록 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  마켓플루바매물목록페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 마켓플루바매물목록페이지조회(), options);
  }

  /**
   * 마켓 - 플루바 매물 상담 권유 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EB%8B%B4%20%EA%B6%8C%EC%9C%A0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓플루바매물상담권유버튼클릭(
    properties: 마켓플루바매물상담권유버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓플루바매물상담권유버튼클릭(properties), options);
  }

  /**
   * 마켓 - 플루바 매물 상세 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  마켓플루바매물상세페이지조회(
    properties: 마켓플루바매물상세페이지조회Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓플루바매물상세페이지조회(properties), options);
  }

  /**
   * 마켓 - 플루바 매물 전화 상담 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EC%A0%84%ED%99%94%20%EC%83%81%EB%8B%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  마켓플루바매물전화상담버튼클릭(
    properties: 마켓플루바매물전화상담버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 마켓플루바매물전화상담버튼클릭(properties), options);
  }

  /**
   * 마켓 - 플루바 매물 탭 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%ED%83%AD%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓플루바매물탭클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마켓플루바매물탭클릭(), options);
  }

  /**
   * 마켓 - 회원 직거래 탭 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EB%A7%88%EC%BC%93%20-%20%ED%9A%8C%EC%9B%90%20%EC%A7%81%EA%B1%B0%EB%9E%98%20%ED%83%AD%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  마켓회원직거래탭클릭(
    options?: EventOptions,
  ) {
    return this.track(new 마켓회원직거래탭클릭(), options);
  }

  /**
   * 서베이 - 시작 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%84%9C%EB%B2%A0%EC%9D%B4%20-%20%EC%8B%9C%EC%9E%91%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 서베이 이름)
   * @param options Amplitude event options.
   */
  서베이시작버튼클릭(
    properties: 서베이시작버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 서베이시작버튼클릭(properties), options);
  }

  /**
   * 서베이 - 취소 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%84%9C%EB%B2%A0%EC%9D%B4%20-%20%EC%B7%A8%EC%86%8C%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  서베이취소버튼클릭(
    properties: 서베이취소버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 서베이취소버튼클릭(properties), options);
  }

  /**
   * 에러 발생
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%97%90%EB%9F%AC%20%EB%B0%9C%EC%83%9D)
   *
   * Owner: Jonghoon Son
   *
   * @param properties The event's properties (e.g. 에러 내용)
   * @param options Amplitude event options.
   */
  에러발생(
    properties: 에러발생Properties,
    options?: EventOptions,
  ) {
    return this.track(new 에러발생(properties), options);
  }

  /**
   * 오토 - 더 자세히 알아보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%98%A4%ED%86%A0%20-%20%EB%8D%94%20%EC%9E%90%EC%84%B8%ED%9E%88%20%EC%95%8C%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  오토더자세히알아보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 오토더자세히알아보기버튼클릭(), options);
  }

  /**
   * 오토 - 최저가 문의 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%98%A4%ED%86%A0%20-%20%EC%B5%9C%EC%A0%80%EA%B0%80%20%EB%AC%B8%EC%9D%98%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  오토최저가문의버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 오토최저가문의버튼클릭(), options);
  }

  /**
   * 오토 - 플루바 오토 문의하기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%98%A4%ED%86%A0%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EC%98%A4%ED%86%A0%20%EB%AC%B8%EC%9D%98%ED%95%98%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  오토플루바오토문의하기버튼클릭(
    properties?: 오토플루바오토문의하기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 오토플루바오토문의하기버튼클릭(properties), options);
  }

  /**
   * 유저 - 회원가입 완료
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9C%A0%EC%A0%80%20-%20%ED%9A%8C%EC%9B%90%EA%B0%80%EC%9E%85%20%EC%99%84%EB%A3%8C)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  유저회원가입완료(
    options?: EventOptions,
  ) {
    return this.track(new 유저회원가입완료(), options);
  }

  /**
   * 이벤트 - 값진년 공유하기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EA%B3%B5%EC%9C%A0%ED%95%98%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 유저 ID)
   * @param options Amplitude event options.
   */
  이벤트값진년공유하기버튼클릭(
    properties: 이벤트값진년공유하기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년공유하기버튼클릭(properties), options);
  }

  /**
   * 이벤트 - 값진년 내 트랙터 팔기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%82%B4%20%ED%8A%B8%EB%9E%99%ED%84%B0%20%ED%8C%94%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  이벤트값진년내트랙터팔기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년내트랙터팔기버튼클릭(), options);
  }

  /**
   * 이벤트 - 값진년 농협 중고 농기계 구입자금 안내 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%86%8D%ED%98%91%20%EC%A4%91%EA%B3%A0%20%EB%86%8D%EA%B8%B0%EA%B3%84%20%EA%B5%AC%EC%9E%85%EC%9E%90%EA%B8%88%20%EC%95%88%EB%82%B4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  이벤트값진년농협중고농기계구입자금안내버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년농협중고농기계구입자금안내버튼클릭(), options);
  }

  /**
   * 이벤트 - 값진년 마케팅 수신 동의 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%A7%88%EC%BC%80%ED%8C%85%20%EC%88%98%EC%8B%A0%20%EB%8F%99%EC%9D%98%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 유저 ID)
   * @param options Amplitude event options.
   */
  이벤트값진년마케팅수신동의버튼클릭(
    properties: 이벤트값진년마케팅수신동의버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년마케팅수신동의버튼클릭(properties), options);
  }

  /**
   * 이벤트 - 값진년 마켓 살펴보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%A7%88%EC%BC%93%20%EC%82%B4%ED%8E%B4%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  이벤트값진년마켓살펴보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년마켓살펴보기버튼클릭(), options);
  }

  /**
   * 이벤트 - 값진년 모달 닫기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%AA%A8%EB%8B%AC%20%EB%8B%AB%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  이벤트값진년모달닫기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년모달닫기버튼클릭(), options);
  }

  /**
   * 이벤트 - 값진년 모달 보러가기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%AA%A8%EB%8B%AC%20%EB%B3%B4%EB%9F%AC%EA%B0%80%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  이벤트값진년모달보러가기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년모달보러가기버튼클릭(), options);
  }

  /**
   * 이벤트 - 값진년 보러가기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EB%B3%B4%EB%9F%AC%EA%B0%80%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  이벤트값진년보러가기버튼클릭(
    properties: 이벤트값진년보러가기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년보러가기버튼클릭(properties), options);
  }

  /**
   * 이벤트 - 값진년 직거래 바로 가기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%EC%A7%81%EA%B1%B0%EB%9E%98%20%EB%B0%94%EB%A1%9C%20%EA%B0%80%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  이벤트값진년직거래바로가기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년직거래바로가기버튼클릭(), options);
  }

  /**
   * 이벤트 - 값진년 혜택 받기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%9D%B4%EB%B2%A4%ED%8A%B8%20-%20%EA%B0%92%EC%A7%84%EB%85%84%20%ED%98%9C%ED%83%9D%20%EB%B0%9B%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 유저 ID)
   * @param options Amplitude event options.
   */
  이벤트값진년혜택받기버튼클릭(
    properties: 이벤트값진년혜택받기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 이벤트값진년혜택받기버튼클릭(properties), options);
  }

  /**
   * 정보 - 목록 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%A0%95%EB%B3%B4%20-%20%EB%AA%A9%EB%A1%9D%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  정보목록페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 정보목록페이지조회(), options);
  }

  /**
   * 정보 - 상세 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%EC%A0%95%EB%B3%B4%20-%20%EC%83%81%EC%84%B8%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param properties The event's properties (e.g. 게시글 제목)
   * @param options Amplitude event options.
   */
  정보상세페이지조회(
    properties: 정보상세페이지조회Properties,
    options?: EventOptions,
  ) {
    return this.track(new 정보상세페이지조회(properties), options);
  }

  /**
   * 홈 - 강력 추천 모아보기 매물 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%EA%B0%95%EB%A0%A5%20%EC%B6%94%EC%B2%9C%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%A7%A4%EB%AC%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 분류)
   * @param options Amplitude event options.
   */
  홈강력추천모아보기매물클릭(
    properties: 홈강력추천모아보기매물클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈강력추천모아보기매물클릭(properties), options);
  }

  /**
   * 홈 - 내 트랙터 판매 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%EB%82%B4%20%ED%8A%B8%EB%9E%99%ED%84%B0%20%ED%8C%90%EB%A7%A4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈내트랙터판매버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈내트랙터판매버튼클릭(), options);
  }

  /**
   * 홈 - 보유 트랙터 판매 권유 모달 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%08%ED%99%88%20-%20%EB%B3%B4%EC%9C%A0%20%ED%8A%B8%EB%9E%99%ED%84%B0%20%ED%8C%90%EB%A7%A4%20%EA%B6%8C%EC%9C%A0%20%EB%AA%A8%EB%8B%AC%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 버튼 이름)
   * @param options Amplitude event options.
   */
  홈보유트랙터판매권유모달버튼클릭(
    properties: 홈보유트랙터판매권유모달버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈보유트랙터판매권유모달버튼클릭(properties), options);
  }

  /**
   * 홈 - 상담하기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%EC%83%81%EB%8B%B4%ED%95%98%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈상담하기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈상담하기버튼클릭(), options);
  }

  /**
   * 홈 - 지원 프로그램 자세히 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%EC%A7%80%EC%9B%90%20%ED%94%84%EB%A1%9C%EA%B7%B8%EB%9E%A8%20%EC%9E%90%EC%84%B8%ED%9E%88%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈지원프로그램자세히보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈지원프로그램자세히보기버튼클릭(), options);
  }

  /**
   * 홈 - 캐러셀 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%EC%BA%90%EB%9F%AC%EC%85%80%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 캐러셀 정보)
   * @param options Amplitude event options.
   */
  홈캐러셀클릭(
    properties?: 홈캐러셀클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈캐러셀클릭(properties), options);
  }

  /**
   * 홈 - 트랙터 구매 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%8A%B8%EB%9E%99%ED%84%B0%20%EA%B5%AC%EB%A7%A4%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈트랙터구매버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈트랙터구매버튼클릭(), options);
  }

  /**
   * 홈 - 파트너 매물 모아보기 매물 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%A7%A4%EB%AC%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  홈파트너매물모아보기매물클릭(
    properties: 홈파트너매물모아보기매물클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈파트너매물모아보기매물클릭(properties), options);
  }

  /**
   * 홈 - 파트너 매물 모아보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%8C%8C%ED%8A%B8%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈파트너매물모아보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈파트너매물모아보기버튼클릭(), options);
  }

  /**
   * 홈 - 플루바 매물 모아보기 매물 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%A7%A4%EB%AC%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  홈플루바매물모아보기매물클릭(
    properties: 홈플루바매물모아보기매물클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈플루바매물모아보기매물클릭(properties), options);
  }

  /**
   * 홈 - 플루바 매물 모아보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈플루바매물모아보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈플루바매물모아보기버튼클릭(), options);
  }

  /**
   * 홈 - 플루바 오토 살펴보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%94%8C%EB%A3%A8%EB%B0%94%20%EC%98%A4%ED%86%A0%20%EC%82%B4%ED%8E%B4%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈플루바오토살펴보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈플루바오토살펴보기버튼클릭(), options);
  }

  /**
   * 홈 - 할부 배너 매물 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%95%A0%EB%B6%80%20%EB%B0%B0%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈할부배너매물보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈할부배너매물보기버튼클릭(), options);
  }

  /**
   * 홈 - 할부 배너 자세히 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%95%A0%EB%B6%80%20%EB%B0%B0%EB%84%88%20%EC%9E%90%EC%84%B8%ED%9E%88%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈할부배너자세히보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈할부배너자세히보기버튼클릭(), options);
  }

  /**
   * 홈 - 홈 페이지 조회
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%99%88%20%ED%8E%98%EC%9D%B4%EC%A7%80%20%EC%A1%B0%ED%9A%8C)
   *
   * Owner: Pluva Market
   *
   * @param options Amplitude event options.
   */
  홈홈페이지조회(
    options?: EventOptions,
  ) {
    return this.track(new 홈홈페이지조회(), options);
  }

  /**
   * 홈 - 회원 직거래 매물 모아보기 매물 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%9A%8C%EC%9B%90%20%EC%A7%81%EA%B1%B0%EB%9E%98%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%A7%A4%EB%AC%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 매물 코드)
   * @param options Amplitude event options.
   */
  홈회원직거래매물모아보기매물클릭(
    properties: 홈회원직거래매물모아보기매물클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈회원직거래매물모아보기매물클릭(properties), options);
  }

  /**
   * 홈 - 회원 직거래 매물 모아보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%9A%8C%EC%9B%90%20%EC%A7%81%EA%B1%B0%EB%9E%98%20%EB%A7%A4%EB%AC%BC%20%EB%AA%A8%EC%95%84%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈회원직거래매물모아보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈회원직거래매물모아보기버튼클릭(), options);
  }

  /**
   * 홈 - 회원 직거래 배너 매물 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%9A%8C%EC%9B%90%20%EC%A7%81%EA%B1%B0%EB%9E%98%20%EB%B0%B0%EB%84%88%20%EB%A7%A4%EB%AC%BC%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈회원직거래배너매물보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈회원직거래배너매물보기버튼클릭(), options);
  }

  /**
   * 홈 - 회원 직거래 배너 자세히 보기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%9A%8C%EC%9B%90%20%EC%A7%81%EA%B1%B0%EB%9E%98%20%EB%B0%B0%EB%84%88%20%EC%9E%90%EC%84%B8%ED%9E%88%20%EB%B3%B4%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈회원직거래배너자세히보기버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈회원직거래배너자세히보기버튼클릭(), options);
  }

  /**
   * 홈 - 회원가 확인하기 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%9A%8C%EC%9B%90%EA%B0%80%20%ED%99%95%EC%9D%B8%ED%95%98%EA%B8%B0%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. 유저 ID)
   * @param options Amplitude event options.
   */
  홈회원가확인하기버튼클릭(
    properties: 홈회원가확인하기버튼클릭Properties,
    options?: EventOptions,
  ) {
    return this.track(new 홈회원가확인하기버튼클릭(properties), options);
  }

  /**
   * 홈 - 회원가입 버튼 클릭
   *
   * [View in Tracking Plan](https://data.amplitude.com/pluva-market/Pluva%20Market/events/main/latest/%ED%99%88%20-%20%ED%9A%8C%EC%9B%90%EA%B0%80%EC%9E%85%20%EB%B2%84%ED%8A%BC%20%ED%81%B4%EB%A6%AD)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  홈회원가입버튼클릭(
    options?: EventOptions,
  ) {
    return this.track(new 홈회원가입버튼클릭(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
